


import React, { useState, useEffect, useRef } from "react";  // <-- added useRef
import {
  MessageSquareText,
  AlertTriangle,
  FileSpreadsheet,
  Info,
} from "lucide-react";
import Commentbox from "./Commentbox/Commentbox";
import Loader from "../../../../../presentationals/Loader/Loader.component";
import { getDisbursalData, getEmiBreakdown, getCollectionSummary, getcollectionBreakdown, getDisbursalCalculate, getMisCollectionList, createPtpApi, getPtpListApi, updatePtpApi, deletePtpApi } from "../../API's/Actioncreator";
import StyledTooltip from '../../common/StyledTooltip'
import CustomPopupTable from '../../common/CustomPopupTable'
import moment from "moment";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import styled from "@emotion/styled";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    fontSize: '12px',
    boxShadow: '3px 3px 10px 2px #ccc',
    background: '#fff',
    color: '#000'
  },
}));

const commonMargin = window.innerWidth > 1800 ? "40px" : "20px"
const commonGap = window.innerWidth > 1800 ? "20px" : "14px"
const FONT = "'Inter', system-ui, -apple-system, sans-serif";

const scrollbarStyles = `
  .emi-scroll-container::-webkit-scrollbar { height: 4px; }
  .emi-scroll-container::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 2px; }
  .emi-scroll-container::-webkit-scrollbar-thumb { background: #c1c1c1; border-radius: 2px; }
  .emi-scroll-container::-webkit-scrollbar-thumb:hover { background: #a8a8a8; }
  @keyframes shimmer {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }
  @keyframes scaleIn {
    from { transform: scale(0.95); opacity: 0; }
    to { transform: scale(1); opacity: 1; }
  }
`;

function useWindowSize() {
  const [size, setSize] = useState({ w: window.innerWidth });
  useEffect(() => {
    const fn = () => setSize({ w: window.innerWidth });
    window.addEventListener("resize", fn);
    return () => window.removeEventListener("resize", fn);
  }, []);
  return size;
}

function IconUsers({ color }) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  );
}
function IconDollar({ color }) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="1" x2="12" y2="23" />
      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
    </svg>
  );
}
function IconCheckCircle({ color }) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
      <polyline points="22 4 12 14.01 9 11.01" />
    </svg>
  );
}
function IconAlertCircle({ color }) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  );
}

function StatCard({ customId = 1, originalValue = 0, Icon, iconColor, iconBg, value, label, cardBg, compact, valueColor = "#111827", Border }) {
  return (
    <div style={{ flex: compact ? "1 1 calc(50% - 8px)" : "1 1 0", background: cardBg, borderRadius: 16, padding: compact ? "16px 18px" : "24px 28px", minWidth: 0, boxSizing: "border-box", border: Border }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 10 }}>
        <div style={{ width: compact ? 36 : 44, height: compact ? 36 : 44, borderRadius: "10px", background: iconBg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
          <Icon color={iconColor} />
        </div>
        {!(customId == 0) ? (
          <StyledTooltip value={originalValue}>
            <span style={{ fontSize: "clamp(18px, 2vw, 26px)", fontWeight: 700, color: valueColor, letterSpacing: "-0.5px", lineHeight: 1 }}>{value}</span>
          </StyledTooltip>
        ) : (
          <span style={{ fontSize: "clamp(18px, 2vw, 26px)", fontWeight: 700, color: valueColor, letterSpacing: "-0.5px", lineHeight: 1 }}>{value}</span>
        )}
      </div>
      <p style={{ margin: 0, color: "#4A5565", fontWeight: 400, fontSize: "14px" }}>{label}</p>
    </div>
  );
}

function FinCard({ label, value, pct, compact, originalValue }) {
  return (
    <div style={{ flex: compact ? "1 1 calc(50% - 8px)" : "1 1 0", background: "#FFFFFF", borderRadius: 12, padding: compact ? "14px 16px" : "18px 20px", border: "0.8px solid #E5E7EB", minWidth: 0, boxSizing: "border-box" }}>
      <p style={{ margin: "0 0 0px", fontSize: "14px", color: "#4A5565" }}>{label}</p>
      <StyledTooltip value={originalValue}>
        <p style={{ margin: "4px 0 4px", fontSize: "20px", fontWeight: 700, color: "#101828", letterSpacing: "-0.3px" }}>{value}</p>
      </StyledTooltip>
      <p style={{ margin: "10px 0px 0px 0px", fontSize: "clamp(10px, 12px, 13px)", color: "#6A7282" }}>{pct}</p>
    </div>
  );
}

function EmiCard({ emi, cases, month, amount, collectedamount, breakdown, pct, accentColor, badgeBg, badgeColor, cardWidth, onMessageClick, onCardInfoClick, amountOriginal, collectedamountOriginal, collectableMonthToDate, collectableMonthToDateDisplay }) {
  return (
    <div style={{ width: cardWidth, flexShrink: 0, background: "#fff", borderRadius: 16, padding: "18px", border: "1.6px solid #D1D5DC", boxSizing: "border-box" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
          <span style={{ fontSize: "clamp(11px, 0.9vw, 13px)", fontWeight: 700, color: accentColor }}>{emi} EMI</span>
          <span style={{ background: badgeBg, color: badgeColor, borderRadius: 999, fontSize: "clamp(9px, 0.7vw, 10px)", fontWeight: 600, padding: "6px 12px", whiteSpace: "nowrap" }}>{cases} Cases</span>
        </div>
        <div style={{ display: "flex", gap: '5px' }}>
          <div style={{ width: 28, height: 28, borderRadius: 7, background: "#F3F4F6", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, cursor: "pointer", boxShadow: "0 2px 8px rgba(59, 130, 246, 0.51)" }}>
            <Info size={13} color="#155DFC" onClick={onCardInfoClick} />
          </div>
          <div style={{ width: 28, height: 28, borderRadius: 7, background: "#F3F4F6", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, cursor: "pointer", boxShadow: "0 2px 8px rgba(59, 130, 246, 0.51)" }}>
            <MessageSquareText size={13} color="#155DFC" onClick={onMessageClick} />
          </div>
        </div>
      </div>
      <p style={{ margin: "0 0 2px", fontSize: "14px", color: "#4A5565", fontWeight: 400 }}>Month</p>
      <p style={{ margin: "0 0 12px", fontSize: "24px", fontWeight: 700, color: "#364153", letterSpacing: "-0.3px" }}>{month}</p>
      <p style={{ margin: "0 0 2px", fontSize: "14px", color: "#4A5565", fontWeight: 400 }}>Collectable Amount</p>
      <StyledTooltip value={amountOriginal}>
        <p style={{ margin: "0 0 8px", fontSize: "clamp(18px, 2.5vw, 22px)", fontWeight: 700, color: "#00A63E", letterSpacing: "-0.5px" }}>{amount}</p>
      </StyledTooltip>
      {collectableMonthToDate != null && (
        <>
          <p style={{ margin: "0 0 2px", fontSize: "14px", color: "#4A5565", fontWeight: 400 }}>Collectable Amount Till Date</p>
          <StyledTooltip value={collectableMonthToDate}>
            <p style={{ margin: "0 0 8px", fontSize: "clamp(18px, 2.5vw, 22px)", fontWeight: 700, color: "#00A63E", letterSpacing: "-0.5px" }}>{collectableMonthToDateDisplay}</p>
          </StyledTooltip>
        </>
      )}
      <p style={{ margin: "3px 0 0 2px", fontSize: "14px", color: "#4A5565", fontWeight: 400 }}>Collected Amount</p>
      <StyledTooltip value={collectedamountOriginal}>
        <p style={{ margin: "0 0 8px", fontSize: "clamp(18px, 2.5vw, 22px)", fontWeight: 700, color: "#00A63E", letterSpacing: "-0.5px" }}>{collectedamount}</p>
      </StyledTooltip>
      <div style={{ borderTop: "1px solid #0000001F", paddingTop: 10, marginBottom: 10 }}>
        <p style={{ margin: "0 0 7px", fontSize: "15px", color: "#4A5565", fontWeight: "400" }}>Breakdown</p>
        {breakdown && breakdown?.length > 0 && breakdown?.map ? (
          breakdown?.map((b, i) => (
            <div key={i} style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
              <span style={{ fontSize: window.innerWidth > 1800 ? "15px" : "12px", color: "#4A5565", fontWeight: 400 }}>{b.label}</span>
              <StyledTooltip value={b.originalValue || 0}>
                <span style={{ fontSize: window.innerWidth > 1800 ? "15px" : "12px", fontWeight: 600, color: "#2F5BFF", background: "#EEF4FF" }}>{b.value}</span>
              </StyledTooltip>
            </div>
          ))
        ) : (
          <div style={{ fontSize: window.innerWidth > 1800 ? "16px" : "12px", color: "#9CA3AF" }}>No breakdown data available</div>
        )}
      </div>
      <div style={{ borderTop: "1px solid #F3F4F6", paddingTop: 10 }}>
        <p style={{ margin: "0 0 3px", fontSize: "14px", color: "#4A5565", fontWeight: 400 }}>% of Total Portfolio</p>
        <p style={{ margin: 0, fontSize: "20px", fontWeight: 700, color: "#364153" }}>{pct}</p>
      </div>
    </div>
  );
}

function CollectionSummary({ rate, expected, collected, gap, expectedOriginal, collectedOriginal, gapOriginal }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10, width: "100%" }}>
      <div style={{ background: "#35A04F2B", borderRadius: 12, padding: "18px 20px", border: "1px solid #D1FAE5" }}>
        <p style={{ margin: "0 0 8px", fontSize: "clamp(11px, 0.8vw, 13px)", fontWeight: 400, color: "#6B7280" }}>Overall Collection Rate</p>
        <p style={{ margin: "0 0 16px", fontSize: "clamp(24px, 3vw, 32px)", fontWeight: 700, color: "#327E45", letterSpacing: "-1px", lineHeight: 1 }}>{rate}</p>
        <div style={{ display: "flex", gap: 32 }}>
          <div>
            <p style={{ margin: "0 0 3px", fontSize: "clamp(10px, 0.75vw, 12px)", fontWeight: 400, color: "#686C70" }}>Expected</p>
            <StyledTooltip value={expectedOriginal}>
              <p style={{ margin: 0, fontSize: "clamp(12px, 0.9vw, 14px)", fontWeight: 700, color: "#686C70" }}>{expected}</p>
            </StyledTooltip>
          </div>
          <div>
            <p style={{ margin: "0 0 3px", fontSize: "clamp(10px, 0.75vw, 12px)", fontWeight: 400, color: "#327E45" }}>Collected</p>
            <StyledTooltip value={collectedOriginal}>
              <p style={{ margin: 0, fontSize: "clamp(12px, 0.9vw, 14px)", fontWeight: 700, color: "#327E45" }}>{collected}</p>
            </StyledTooltip>
          </div>
        </div>
      </div>
      <div style={{ background: "#FFF5F5", borderRadius: 12, padding: "18px 20px", border: "1px solid #FECACA", marginTop: '10px' }}>
        <p style={{ margin: "0 0 8px", fontSize: "clamp(11px, 0.8vw, 13px)", fontWeight: 500, color: "#E84E4E" }}>Collection Gap</p>
        <StyledTooltip value={gapOriginal}>
          <p style={{ margin: "0 0 6px", fontSize: "clamp(20px, 2.5vw, 28px)", fontWeight: 700, color: "#E84E4E", letterSpacing: "-0.5px", lineHeight: 1 }}>{gap}</p>
        </StyledTooltip>
        <p style={{ margin: 0, fontSize: "clamp(11px, 0.8vw, 13px)", fontWeight: 400, color: "#E84E4E" }}>Pending collection</p>
      </div>
    </div>
  );
}

export default function DisbursalTracking({ selectedMonth, commonFilter, refreshKey, isManualRefresh, setIsManualRefresh }) {
  const { w } = useWindowSize();

  const [currentFilterDate, setCurrentFilterDate] = useState({ start: "", end: "" });
  const [tableListPopup, setTableListPopup] = useState(false);
  const [activeEmi, setActiveEmi] = useState(null);
  const [InfoActiveEmi, setInfoActiveEmi] = useState(null);
  const [commentsData, setCommentsData] = useState({});
  const [apiData, setApiData] = useState(null);
  const [emiData, setEmiData] = useState(null);
  const [collectionBreakdownData, setcollectionBreakdownData] = useState(null);
  const [collectionSummaryData, setCollectionSummaryData] = useState(null);
  const [loadingDisbursal, setLoadingDisbursal] = useState(false);
  const [loadingEmi, setLoadingEmi] = useState(false);
  const [loadingCollectionBreakdown, setLoadingCollectionBreakdown] = useState(false);
  const [loadingCollectionSummary, setLoadingCollectionSummary] = useState(false);
  const [error, setError] = useState(null);
  const [emiCardShow, setemiCardShow] = useState("emi");

  const [showCalculator, setShowCalculator] = useState(false);
  const [calcDisbursedInput, setCalcDisbursedInput] = useState("");
  const [calcResults, setCalcResults] = useState(null);
  const [calcError, setCalcError] = useState(null);
  const [loader, setLoader] = useState(false);

  const [expandCollected, setExpandCollected] = useState(false);
  const [expandDefaulted, setExpandDefaulted] = useState(false);
  const [expandCollectable, setExpandCollectable] = useState(false);
  const [expandCollectableToDate, setExpandCollectableToDate] = useState(false);
  const [expandPending, setExpandPending] = useState(false);
  const [collectionPopupTab, setCollectionPopupTab] = useState(null);

  const [showPtpModal, setShowPtpModal] = useState(false);
  const [ptpAmount, setPtpAmount] = useState("");
  const [ptpMonth, setPtpMonth] = useState("");
  const [ptpYear, setPtpYear] = useState("");
  const [editingPtpRecord, setEditingPtpRecord] = useState(null);
  const [ptpRecords, setPtpRecords] = useState(() => {
    try {
      const saved = localStorage.getItem("ptp_records");
      return saved ? JSON.parse(saved) : [];
    } catch (e) {
      return [];
    }
  });

  const currentYear = new Date().getFullYear();
  const yearsList = Array.from({ length: 11 }, (_, i) => currentYear - 5 + i);
  const monthsList = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  const fetchPtpList = () => {
    const startDate = commonFilter?.fromDate ? moment(commonFilter.fromDate, "YYYY-MM-DD").format("DD-MM-YYYY") : "";
    const endDate = commonFilter?.toDate ? moment(commonFilter.toDate, "YYYY-MM-DD").format("DD-MM-YYYY") : "";
    const nbfcId = commonFilter?.nbfc ?? "";

    getPtpListApi({ startDate, endDate, nbfcId }, (res) => {
      const list = res?.data || res;
      if (Array.isArray(list)) {
        setPtpRecords(list);
      }
    }, (err) => {
      console.warn("Failed to fetch PTP list from API (using localStorage fallback):", err);
      try {
        const saved = localStorage.getItem("ptp_records") || "[]";
        setPtpRecords(JSON.parse(saved));
      } catch (e) {
        setPtpRecords([]);
      }
    });
  };

  useEffect(() => {
    fetchPtpList();
  }, [commonFilter, refreshKey]);

  const handleSavePtp = (e) => {
    e.preventDefault();
    if (!ptpAmount || !ptpMonth || !ptpYear) return;

    const formattedPtpDate = `01-${ptpMonth.padStart(2, "0")}-${ptpYear}`;
    const startDate = commonFilter?.fromDate ? moment(commonFilter.fromDate, "YYYY-MM-DD").format("DD-MM-YYYY") : "";
    const endDate = commonFilter?.toDate ? moment(commonFilter.toDate, "YYYY-MM-DD").format("DD-MM-YYYY") : "";

    const payload = {
      id: editingPtpRecord ? editingPtpRecord.id : undefined,
      amount: parseFloat(ptpAmount),
      ptpDate: formattedPtpDate,
      startDate,
      endDate,
      nbfcId: commonFilter?.nbfc ?? ""
    };

    console.log("=== Promise to Pay Submitting ===");
    console.log("PTP Amount:", ptpAmount);
    console.log("PTP Date (dd-mm-yyyy):", formattedPtpDate);
    console.log("Filter Start Date (dd-mm-yyyy):", startDate);
    console.log("Filter End Date (dd-mm-yyyy):", endDate);

    const apiCallback = (res) => {
      fetchPtpList();
      resetForm();
    };

    const apiFallback = (err) => {
      console.warn("Failed PTP API call (using localStorage fallback):", err);
      const newRecord = {
        id: editingPtpRecord ? editingPtpRecord.id : Date.now(),
        amount: parseFloat(ptpAmount),
        month: `${ptpYear}-${ptpMonth}`,
        formattedDate: formattedPtpDate,
        createdDate: new Date().toLocaleDateString('en-IN', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        })
      };

      let updatedRecords;
      if (editingPtpRecord) {
        updatedRecords = ptpRecords.map(r => r.id === editingPtpRecord.id ? newRecord : r);
      } else {
        updatedRecords = [newRecord, ...ptpRecords];
      }

      setPtpRecords(updatedRecords);
      localStorage.setItem("ptp_records", JSON.stringify(updatedRecords));
      resetForm();
    };

    if (editingPtpRecord) {
      updatePtpApi(payload, apiCallback, apiFallback);
    } else {
      createPtpApi(payload, apiCallback, apiFallback);
    }
  };

  const handleDeletePtp = (record) => {
    const apiCallback = (res) => {
      fetchPtpList();
    };

    const apiFallback = (err) => {
      console.warn("Failed Delete PTP API call (using localStorage fallback):", err);
      const updatedRecords = ptpRecords.filter(r => r.id !== record.id);
      setPtpRecords(updatedRecords);
      localStorage.setItem("ptp_records", JSON.stringify(updatedRecords));
    };

    deletePtpApi(record.id, apiCallback, apiFallback);
  };

  const handleEditClick = (record) => {
    setEditingPtpRecord(record);
    setPtpAmount(record.amount);
    
    if (record.month && record.month.includes("-")) {
      const parts = record.month.split("-");
      if (parts[0].length === 4) {
        setPtpYear(parts[0]);
        setPtpMonth(parts[1]);
      } else {
        setPtpMonth(parts[0]);
        setPtpYear(parts[1]);
      }
    } else if (record.formattedDate && record.formattedDate.includes("-")) {
      const parts = record.formattedDate.split("-");
      setPtpMonth(parts[1]);
      setPtpYear(parts[2]);
    }
    
    setShowPtpModal(true);
  };

  const resetForm = () => {
    setPtpAmount("");
    setPtpMonth("");
    setPtpYear("");
    setEditingPtpRecord(null);
    setShowPtpModal(false);
  };

  const formatCurrency = (val) => {
    if (val === null || val === undefined || isNaN(val)) return "₹0";
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    }).format(val);
  };

  const formatLakhs = (val) => {
    if (val === null || val === undefined || isNaN(val)) return "₹0.00 L";
    const lakhs = val / 100000;
    if (lakhs >= 100) {
      return `₹${(lakhs / 100).toFixed(2)} Cr`;
    }
    return `₹${lakhs.toFixed(2)} L`;
  };

  const formatCalcValue = (val) => {
    if (val === null || val === undefined || isNaN(val)) return "₹0";
    if (val < 100000) {
      return formatCurrency(val);
    }
    return formatLakhs(val);
  };

  const getDefaultCalcResults = () => {
    const pAmt = parseFloat(currentData?.breakdown?.principalRepaidOriginal) || 0;
    const iAmt = parseFloat(currentData?.breakdown?.interestCollectedOriginal) || 0;
    const fAmt = parseFloat(currentData?.breakdown?.outstandingOriginal) || 0;
    const sumAmt = pAmt + iAmt + fAmt;

    const interestRatePct = apiData?.financialBreakdown?.interest?.percentage !== undefined
      ? parseFloat(apiData.financialBreakdown.interest.percentage)
      : 25.6;
    const processingFeePct = apiData?.financialBreakdown?.processingFee?.percentage !== undefined
      ? parseFloat(apiData.financialBreakdown.processingFee.percentage)
      : 7.6;

    return {
      principal: pAmt,
      principalFormatted: currentData?.breakdown?.principalRepaid || "₹0.00 L",
      interest: iAmt,
      interestFormatted: currentData?.breakdown?.interestCollected || "₹0.00 L",
      processingFee: fAmt,
      processingFeeFormatted: currentData?.breakdown?.processingFeeAmount || "₹0.00 L",
      totalFormatted: formatLakhs(sumAmt),
      rawSum: sumAmt,
      principalPct: parseFloat(currentData?.breakdown?.principalPct) || 0,
      interestPct: parseFloat(currentData?.breakdown?.interestPct) || 0,
      processingFeePct: parseFloat(currentData?.breakdown?.processingFeePct) || 0,
      interestRatio: isNaN(interestRatePct) ? 25.6 : interestRatePct,
      processingFeeRatio: isNaN(processingFeePct) ? 7.6 : processingFeePct
    };
  };

  const runCalculation = (disbursedVal) => {
    const amt = parseFloat(disbursedVal);
    setCalcError(null);
    if (isNaN(amt) || amt <= 0) {
      setCalcResults(getDefaultCalcResults());
      return;
    }

    const interestRatePct = apiData?.financialBreakdown?.interest?.percentage !== undefined
      ? parseFloat(apiData.financialBreakdown.interest.percentage)
      : 25.6;
    const processingFeePct = apiData?.financialBreakdown?.processingFee?.percentage !== undefined
      ? parseFloat(apiData.financialBreakdown.processingFee.percentage)
      : 7.6;

    const principalVal = parseFloat(currentData?.breakdown?.principalRepaidOriginal) || 0;
    const interestVal = parseFloat(currentData?.breakdown?.interestCollectedOriginal) || 0;
    const processingFeeVal = parseFloat(currentData?.breakdown?.outstandingOriginal) || 0;

    const data = {
      "disbursementAmount": amt,
      "knownPrincipal": principalVal,
      "knownInterest": interestVal,
      "knownProcessingFee": processingFeeVal
    };
    setLoader(true)
    getDisbursalCalculate(
      data,
      callback => {
        setLoader(false);
        if (callback?.success === true) {
          setCalcResults({
            principal: callback?.data?.allocation?.principal?.amount ?? 0,
            principalFormatted: callback?.data?.allocation?.principal?.formatted ?? "",
            interest: callback?.data?.allocation?.interest?.amount ?? 0,
            interestFormatted: callback?.data?.allocation?.interest?.formatted ?? "",
            processingFee: callback?.data?.allocation?.processing_fee?.amount ?? 0,

            processingFeeFormatted: callback?.data?.allocation?.processing_fee?.formatted ?? "",
            totalFormatted: callback?.data?.total_portfolio_impact?.formatted ?? "",
            rawSum: callback?.data?.total_portfolio_impact?.raw_sum ?? 0,
            principalPct: callback?.data?.allocation?.principal?.percentage_of_total ?? 0,
            interestPct: callback?.data?.allocation?.interest?.percentage_of_total ?? 0,
            processingFeePct: callback?.data?.allocation?.processing_fee?.percentage_of_total ?? 0,
            interestRatio: callback?.data?.interest_rate_pct ?? interestRatePct,
            processingFeeRatio: callback?.data?.processing_fee_pct ?? processingFeePct
          });
        } else {
          const errMsg = callback?.error || callback?.message || "An unexpected error occurred during calculation.";
          setCalcError(errMsg);
        }
      },
      err => {
        setLoader(false);
        const errMsg = err?.message || "Failed to connect to the calculation server.";
        setCalcError(errMsg);
      }
    );
  };

  const handleOpenCalculator = () => {
    const origAmount = parseFloat(currentData.stats?.amountDisbursedOriginal) || 0;
    setCalcDisbursedInput(origAmount || "");
    setCalcError(null);
    setCalcResults(getDefaultCalcResults());
    runCalculation(origAmount);
    setShowCalculator(true);
  };

  useEffect(() => {
    if (showCalculator) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
    }
    return () => { document.body.style.overflow = "visible"; };
  }, [showCalculator]);


  // ── One ref per API — each can be cancelled independently ────────────────
  const abortDisbursal = useRef(null);
  const abortEmi = useRef(null);
  const abortCollectionBreakdown = useRef(null);
  const abortCollectionSummary = useRef(null);
  // ─────────────────────────────────────────────────────────────────────────

  const addComment = (emiNo, newComment) => {
    setCommentsData(prev => ({ ...prev, [emiNo]: [newComment, ...(prev[emiNo] || [])] }));
  };

  const handleInfoPopup = (e) => {
    setInfoActiveEmi(e);
    setTableListPopup(true);
  };

  useEffect(() => {
    if (activeEmi) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
    }
    return () => { document.body.style.overflow = "visible"; };
  }, [activeEmi]);

  useEffect(() => {
    if (!selectedMonth || selectedMonth.length === 0) return;

    // ── Cancel any in-flight requests and clear stale data ──────────────
    // abortDisbursal.current?.abort();
    abortEmi.current?.abort();
    abortCollectionBreakdown.current?.abort();
    // abortCollectionSummary.current?.abort();

    // abortDisbursal.current = new AbortController();
    abortEmi.current = new AbortController();
    abortCollectionBreakdown.current = new AbortController();
    // abortCollectionSummary.current   = new AbortController();

    // Clear previous data immediately so stale values don't show
    setApiData(null);
    setEmiData(null);
    setcollectionBreakdownData(null);
    setCollectionSummaryData(null);
    setError(null);
    // ────────────────────────────────────────────────────────────────────

    // Capture signals for this render cycle
    // const signalDisbursal         = abortDisbursal.current.signal;
    const signalEmi = abortEmi.current.signal;
    const signalCollBreakdown = abortCollectionBreakdown.current.signal;
    // const signalCollSummary       = abortCollectionSummary.current.signal;

    // Turn on all skeletons
    setLoadingDisbursal(true);
    setLoadingEmi(true);
    setLoadingCollectionBreakdown(true);
    setLoadingCollectionSummary(true);

    const startDate = moment(commonFilter?.fromDate, "YYYY-MM-DD").format("DD-MM-YYYY");
    const endDate = moment(commonFilter?.toDate, "YYYY-MM-DD").format("DD-MM-YYYY");
    const nbfc = commonFilter?.nbfc ?? "";

    setCurrentFilterDate({ start: startDate, end: endDate });

    // ── 1. Disbursal Data ────────────────────────────────────────────────
    // getDisbursalData(
    //   startDate, endDate, nbfc,
    //   (res) => {
    //     if (signalDisbursal.aborted) return;
    //     if (res?.status === 200 && res?.data) setApiData(res.data);
    //     setLoadingDisbursal(false);
    //   },
    //   (err) => {
    //     if (signalDisbursal.aborted) return;
    //     setError("Disbursal failed: " + err?.message);
    //     setLoadingDisbursal(false);
    //   },
    //   signalDisbursal,
    // );

    // ── 2. EMI Breakdown ─────────────────────────────────────────────────
    getEmiBreakdown(
      startDate, endDate, nbfc,
      (res) => {
        if (signalEmi.aborted) return;
        if (res?.status === 200 && res?.data) setEmiData(res.data);
        setLoadingEmi(false);
      },
      (err) => {
        if (signalEmi.aborted) return;
        setError("EMI failed: " + err?.message);
        setLoadingEmi(false);
      },
      signalEmi,
    );

    // ── 3. Collection Breakdown ──────────────────────────────────────────
    getcollectionBreakdown(
      startDate, endDate, nbfc,
      (res) => {
        if (signalCollBreakdown.aborted) return;
        if (res?.status === 200 && res?.data) setcollectionBreakdownData(res.data);
        setLoadingCollectionBreakdown(false);
      },
      (err) => {
        if (signalCollBreakdown.aborted) return;
        setError("Collection breakdown failed: " + err?.message);
        setLoadingCollectionBreakdown(false);
      },
      signalCollBreakdown,
    );

    // ── 4. Collection Summary ────────────────────────────────────────────
    // getCollectionSummary(
    //   startDate, endDate, nbfc,
    //   (res) => {
    //     if (signalCollSummary.aborted) return;
    //     if (res?.status === 200 && res?.data) setCollectionSummaryData(res.data);
    //     setLoadingCollectionSummary(false);
    //   },
    //   (err) => {
    //     if (signalCollSummary.aborted) return;
    //     setError("Collection summary failed: " + err?.message);
    //     setLoadingCollectionSummary(false);
    //   },
    //   signalCollSummary,
    // );


    // ── Cleanup: abort all on unmount or before next effect run ──────────
    return () => {
      // abortDisbursal.current?.abort();
      abortEmi.current?.abort();
      abortCollectionBreakdown.current?.abort();
      // abortCollectionSummary.current?.abort();
    };
  }, [selectedMonth, commonFilter]);

  useEffect(() => {
    if (!selectedMonth || selectedMonth.length === 0) return;
    abortDisbursal.current?.abort();
    abortCollectionSummary.current?.abort();

    abortDisbursal.current = new AbortController();
    abortCollectionSummary.current = new AbortController();

    const signalDisbursal = abortDisbursal.current.signal;
    const signal = abortCollectionSummary.current.signal;

    const startDate = moment(
      commonFilter?.fromDate,
      "YYYY-MM-DD"
    ).format("DD-MM-YYYY");

    const endDate = moment(
      commonFilter?.toDate,
      "YYYY-MM-DD"
    ).format("DD-MM-YYYY");

    const nbfc = commonFilter?.nbfc ?? "";

    setLoadingCollectionSummary(true);

    getDisbursalData(
      startDate, endDate, nbfc, isManualRefresh,
      (res) => {
        if (signalDisbursal.aborted) return;
        if (res?.status === 200 && res?.data) setApiData(res.data);
        setLoadingDisbursal(false);
      },
      (err) => {
        if (signalDisbursal.aborted) return;
        setError("Disbursal failed: " + err?.message);
        setLoadingDisbursal(false);
      },
      signalDisbursal,
    );

    getCollectionSummary(
      startDate,
      endDate,
      nbfc,
      isManualRefresh,
      (res) => {
        if (signal.aborted) return;

        if (res?.status === 200 && res?.data) {
          setCollectionSummaryData(res.data);
        }

        setLoadingCollectionSummary(false);
      },
      (err) => {
        if (signal.aborted) return;

        setError("Collection summary failed: " + err?.message);

        setLoadingCollectionSummary(false);
      },
      signal
    );
    setIsManualRefresh(false)

    return () => {
      abortDisbursal.current?.abort();
      abortCollectionSummary.current?.abort();
    };
  }, [selectedMonth, commonFilter, refreshKey]);

  // ── Data mapping (unchanged from original) ───────────────────────────────
  const currentData = apiData ? {
    stats: {
      totalCases: apiData?.totalCasesDisbursed || 0,
      amountDisbursed: apiData?.amountDisbursedDisplay || "0",
      amountDisbursedOriginal: apiData?.amountDisbursed || "0",
      loansWithPF: apiData?.loansWithPF || 0,
      loansWithPFDISPALY: apiData?.loansWithPFDisplay || 0,
      loansWithoutPF: apiData?.loansWithoutPF || 0,
      loansWithoutPFDISPLAY: apiData?.loansWithoutPFDisplay || 0,
      freshCases: `${apiData?.freshCases || 0} (${apiData?.freshPercentage}%)`,
      RepeatCases: `${apiData?.repeatCases || 0} (${apiData?.repeatPercentage}%)`,
      FreshAmount: `${apiData?.freshDisburseAmountDisplay || 0}`,
      FreshAmountOrignal: `${apiData?.freshDisburseAmount || 0}`,
      RepeatAmount: `${apiData?.repeatDisburseAmountDisplay || 0}`,
      RepeatAmountOrignal: `${apiData?.repeatDisburseAmount || 0}`,
    },
    breakdown: {
      totalDisbursed: apiData?.amountDisbursedDisplay || "0",
      principalRepaidOriginal: apiData?.financialBreakdown?.principal?.amount || "0",
      principalRepaid: apiData?.financialBreakdown?.principal?.display || "0",
      interestCollectedOriginal: apiData?.financialBreakdown?.interest?.amount || "0",
      interestCollected: apiData?.financialBreakdown?.interest?.display || "0",
      outstandingOriginal: apiData?.financialBreakdown?.processingFee?.amount || "0",
      outstanding: apiData?.financialBreakdown?.processingFee?.display || "0",
      principalPct: apiData?.financialBreakdown?.principal?.percentage || "0",
      interestPct: apiData?.financialBreakdown?.interest?.percentage || "0",
      processingFeePct: apiData?.financialBreakdown?.processingFee?.percentage || "0",
      chargesPct: apiData?.financialBreakdown?.charges?.percentage || "0",
      processingFeeAmount: apiData?.financialBreakdown?.processingFee?.display || "0",
      chargesAmount: apiData?.financialBreakdown?.charges?.display || "0",
      chargesAmountOriginal: apiData?.financialBreakdown?.charges?.amount || "0",
    },
    collection: collectionSummaryData ? {
      collectionRate: `${collectionSummaryData?.collectionRate.toFixed(1)}%`,
      totalDue: `${collectionSummaryData?.totalDueDisplay || 0}`,
      totalDueOriginal: collectionSummaryData?.totalDue || 0,
      totalCollected: `${collectionSummaryData?.totalCollectedDisplay || 0}`,
      totalCollectedOriginal: collectionSummaryData?.totalCollected || 0,
      collectionGap: `${collectionSummaryData?.collectionGapDisplay}`,
      collectionGapOriginal: collectionSummaryData?.collectionGap || 0,
      pending: `${collectionSummaryData?.pendingDisplay || 0}`,
      pendingOriginal: collectionSummaryData?.pending || 0,
      // defaulted: `${collectionSummaryData?.defaultedDisplay}`,
      // defaultedOriginal: collectionSummaryData?.defaulted || 0,
      defaulted: `${collectionSummaryData?.defaultedEmiAmountDisplay}`,
      defaultedOriginal: collectionSummaryData?.defaultedEmiAmount || 0,

      defaultedOverdueInterest: `${collectionSummaryData?.defaultedOverdueInterestDisplay}`,
      defaultedOverdueInterestOriginal: collectionSummaryData?.defaultedOverdueInterest || 0,
      defaultedPenalty: `${collectionSummaryData?.defaultedPenaltyDisplay}`,
      defaultedPenaltyOriginal: collectionSummaryData?.defaultedPenalty || 0,
      defaultedBounce: `${collectionSummaryData?.defaultedBounceChargeDisplay}`,
      defaultedBounceOriginal: collectionSummaryData?.defaultedBounceCharge || 0,

      totalCollectedTillDate: `${collectionSummaryData?.collectableToDateDisplay || 0}`,
      totalCollectedOriginalTillDate: collectionSummaryData?.collectableToDate || 0,
      totalCollectedPastDue: collectionSummaryData?.totalCollectedPastDue || 0,
      totalCollectedPastDueDisplay: collectionSummaryData?.totalCollectedPastDueDisplay || 0,
      totalCollectedFutureDue: collectionSummaryData?.totalCollectedFutureDue || 0,
      totalCollectedFutureDueDisplay: collectionSummaryData?.totalCollectedFutureDueDisplay || 0,

      collectablePrincipal: collectionSummaryData?.collectablePrincipal || 0,
      collectablePrincipalDisplay: formatCalcValue(collectionSummaryData?.collectablePrincipal || 0),
      collectableInterest: collectionSummaryData?.collectableInterest || 0,
      collectableInterestDisplay: formatCalcValue(collectionSummaryData?.collectableInterest || 0),
      collectableOverdueInterest: collectionSummaryData?.collectableOverdueInterest || 0,
      collectableOverdueInterestDisplay: formatCalcValue(collectionSummaryData?.collectableOverdueInterest || 0),
      collectablePenalty: collectionSummaryData?.collectablePenalty || 0,
      collectablePenaltyDisplay: formatCalcValue(collectionSummaryData?.collectablePenalty || 0),
      collectableBounce: collectionSummaryData?.collectableBounce || 0,
      collectableBounceDisplay: formatCalcValue(collectionSummaryData?.collectableBounce || 0),
      collectableWaived: collectionSummaryData?.collectableWaived || 0,
      collectableWaivedDisplay: formatCalcValue(collectionSummaryData?.collectableWaived || 0),

      collectableToDatePrincipal: collectionSummaryData?.collectableToDatePrincipal || 0,
      collectableToDatePrincipalDisplay: collectionSummaryData?.collectableToDatePrincipalDisplay || "₹0.00",
      collectableToDateInterest: collectionSummaryData?.collectableToDateInterest || 0,
      collectableToDateInterestDisplay: collectionSummaryData?.collectableToDateInterestDisplay || "₹0.00",
      collectableToDateOverdueInterest: collectionSummaryData?.collectableToDateOverdueInterest || 0,
      collectableToDateOverdueInterestDisplay: collectionSummaryData?.collectableToDateOverdueInterestDisplay || "₹0.00",
      collectableToDatePenalty: collectionSummaryData?.collectableToDatePenalty || 0,
      collectableToDatePenaltyDisplay: collectionSummaryData?.collectableToDatePenaltyDisplay || "₹0.00",
      collectableToDateBounce: collectionSummaryData?.collectableToDateBounce || 0,
      collectableToDateBounceDisplay: collectionSummaryData?.collectableToDateBounceDisplay || "₹0.00",
      collectableToDateWaived: collectionSummaryData?.collectableToDateWaived || 0,
      collectableToDateWaivedDisplay: collectionSummaryData?.collectableToDateWaivedDisplay || "₹0.00",

      collectedPrincipal: collectionSummaryData?.collectedPrincipal || 0,
      collectedPrincipalDisplay: collectionSummaryData?.collectedPrincipalDisplay || "₹0.00",
      collectedInterest: collectionSummaryData?.collectedInterest || 0,
      collectedInterestDisplay: collectionSummaryData?.collectedInterestDisplay || "₹0.00",
      collectedOverdueInterest: collectionSummaryData?.collectedOverdueInterest || 0,
      collectedOverdueInterestDisplay: collectionSummaryData?.collectedOverdueInterestDisplay || "₹0.00",
      collectedPenalty: collectionSummaryData?.collectedPenalty || 0,
      collectedPenaltyDisplay: collectionSummaryData?.collectedPenaltyDisplay || "₹0.00",
      collectedBounce: collectionSummaryData?.collectedBounce || 0,
      collectedBounceDisplay: collectionSummaryData?.collectedBounceDisplay || "₹0.00",
      collectedWaived: collectionSummaryData?.collectedWaived || 0,
      collectedWaivedDisplay: collectionSummaryData?.collectedWaivedDisplay || "₹0.00",

      pendingPrincipal: collectionSummaryData?.pendingPrincipal || 0,
      pendingPrincipalDisplay: collectionSummaryData?.pendingPrincipalDisplay || "₹0.00",
      pendingInterest: collectionSummaryData?.pendingInterest || 0,
      pendingInterestDisplay: collectionSummaryData?.pendingInterestDisplay || "₹0.00",
      pendingOverdueInterest: collectionSummaryData?.pendingOverdueInterest || 0,
      pendingOverdueInterestDisplay: collectionSummaryData?.pendingOverdueInterestDisplay || "₹0.00",
      pendingPenalty: collectionSummaryData?.pendingPenalty || 0,
      pendingPenaltyDisplay: collectionSummaryData?.pendingPenaltyDisplay || "₹0.00",
      pendingBounce: collectionSummaryData?.pendingBounce || 0,
      pendingBounceDisplay: collectionSummaryData?.pendingBounceDisplay || "₹0.00",
      pendingWaived: collectionSummaryData?.pendingWaived || 0,
      pendingWaivedDisplay: collectionSummaryData?.pendingWaivedDisplay || "₹0.00",

      defaultedPrincipal: collectionSummaryData?.defaultedPrincipal || 0,
      defaultedPrincipalDisplay: collectionSummaryData?.defaultedPrincipalDisplay || "₹0.00",
      defaultedInterest: collectionSummaryData?.defaultedInterest || 0,
      defaultedInterestDisplay: collectionSummaryData?.defaultedInterestDisplay || "₹0.00",
      defaultedWaived: collectionSummaryData?.defaultedWaived || 0,
      defaultedWaivedDisplay: collectionSummaryData?.defaultedWaivedDisplay || "₹0.00",
    } : null,
  } : {
    stats: { totalCases: 0, amountDisbursed: "0", amountDisbursedOriginal: 0, loansWithPF: 0, loansWithoutPF: 0 },
    breakdown: { totalDisbursed: "0", principalRepaid: "0", interestCollected: "0", outstanding: "0", principalPct: "0", interestPct: "0", processingFeePct: "0", chargesPct: "0", processingFeeAmount: "0", chargesAmount: "0", chargesAmountOriginal: "0", interestCollectedOriginal: "0", outstandingOriginal: "0", principalRepaidOriginal: "0" },
    collection: null,
  };

  // ── Skeleton components ───────────────────────────────────────────────────
  function SkeletonBox({ width = "100%", height = 16, borderRadius = 8, style = {} }) {
    return (
      <div style={{ width, height, borderRadius, background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)", backgroundSize: "200% 100%", animation: "shimmer 1.4s infinite", flexShrink: 0, ...style }} />
    );
  }

  function DisbursalStatsSkeleton({ compact, count = 4 }) {
    return (
      <div style={{ display: "flex", flexWrap: "wrap", gap: "14px", marginBottom: "20px" }}>
        {Array(count).fill(0).map((_, i) => (
          <div key={i} style={{ flex: compact ? "1 1 calc(50% - 8px)" : "1 1 0", borderRadius: 16, padding: compact ? "16px 18px" : "24px 28px", background: "#F9FAFB", border: "0.8px solid #E5E7EB", minWidth: 0, boxSizing: "border-box", display: "flex", flexDirection: "column", gap: 10 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <SkeletonBox width={44} height={44} borderRadius={10} />
              <SkeletonBox width={90} height={26} />
            </div>
            <SkeletonBox width="60%" height={13} />
          </div>
        ))}
      </div>
    );
  }

  function FinancialBreakdownSkeleton({ isXs }) {
    return (
      <div style={{ background: "#F9FAFB", borderRadius: 16, padding: "24px 28px", border: "0.8px solid #E5E7EB", marginBottom: "20px" }}>
        <SkeletonBox width={180} height={20} style={{ marginBottom: 18 }} />
        <div style={{ display: "flex", flexWrap: isXs ? "wrap" : "nowrap", gap: "14px" }}>
          {[1, 2, 3].map(i => (
            <div key={i} style={{ flex: isXs ? "1 1 calc(50% - 8px)" : "1 1 0", background: "#fff", borderRadius: 12, padding: "18px 20px", border: "0.8px solid #E5E7EB", minWidth: 0, display: "flex", flexDirection: "column", gap: 10 }}>
              <SkeletonBox width="55%" height={13} />
              <SkeletonBox width={100} height={22} />
              <SkeletonBox width="40%" height={11} style={{ marginTop: 4 }} />
            </div>
          ))}
        </div>
      </div>
    );
  }

  function EmiSectionSkeleton({ emiCardWidth, summaryWidth }) {
    return (
      <div style={{ display: "flex", gap: "14px", width: "100%", alignItems: "stretch" }}>
        <div style={{ flex: 1, minWidth: 0, overflowX: "hidden", display: "flex", gap: "12px" }}>
          {[1, 2, 3, 4].map(i => (
            <div key={i} style={{ width: emiCardWidth, flexShrink: 0, background: "#fff", borderRadius: 16, padding: "18px", border: "1.6px solid #E5E7EB", boxSizing: "border-box", display: "flex", flexDirection: "column", gap: 10 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <SkeletonBox width={50} height={14} />
                  <SkeletonBox width={70} height={22} borderRadius={999} />
                </div>
                <div style={{ display: "flex", gap: 5 }}>
                  <SkeletonBox width={28} height={28} borderRadius={7} />
                  <SkeletonBox width={28} height={28} borderRadius={7} />
                </div>
              </div>
              <SkeletonBox width={60} height={12} />
              <SkeletonBox width={100} height={28} />
              <SkeletonBox width={120} height={12} />
              <SkeletonBox width={90} height={24} />
              <SkeletonBox width={110} height={12} />
              <SkeletonBox width={90} height={24} />
              <div style={{ borderTop: "1px solid #E5E7EB", paddingTop: 10, display: "flex", flexDirection: "column", gap: 8 }}>
                <SkeletonBox width={80} height={12} />
                {[1, 2, 3].map(j => (
                  <div key={j} style={{ display: "flex", justifyContent: "space-between" }}>
                    <SkeletonBox width="45%" height={12} />
                    <SkeletonBox width="30%" height={12} />
                  </div>
                ))}
              </div>
              <div style={{ borderTop: "1px solid #F3F4F6", paddingTop: 10, display: "flex", flexDirection: "column", gap: 6 }}>
                <SkeletonBox width={120} height={12} />
                <SkeletonBox width={50} height={22} />
              </div>
            </div>
          ))}
        </div>
        <div style={{ width: summaryWidth, flexShrink: 0, display: "flex", flexDirection: "column", gap: 10 }}>
          <div style={{ background: "#f6fdf8", borderRadius: 12, padding: "18px 20px", border: "1px solid #D1FAE5", display: "flex", flexDirection: "column", gap: 10 }}>
            <SkeletonBox width={140} height={12} />
            <SkeletonBox width={80} height={32} />
            <div style={{ display: "flex", gap: 32, marginTop: 4 }}>
              <div style={{ display: "flex", flexDirection: "column", gap: 6 }}><SkeletonBox width={60} height={10} /><SkeletonBox width={80} height={14} /></div>
              <div style={{ display: "flex", flexDirection: "column", gap: 6 }}><SkeletonBox width={60} height={10} /><SkeletonBox width={80} height={14} /></div>
            </div>
          </div>
          <div style={{ background: "#FFF5F5", borderRadius: 12, padding: "18px 20px", border: "1px solid #FECACA", marginTop: 10, display: "flex", flexDirection: "column", gap: 10 }}>
            <SkeletonBox width={110} height={12} />
            <SkeletonBox width={90} height={28} />
            <SkeletonBox width={130} height={10} />
          </div>
        </div>
      </div>
    );
  }

  function CollectionStatsSkeleton({ isXs }) {
    return (
      <>
        <div style={{ display: "grid", gridTemplateColumns: isXs ? "1fr 1fr" : "repeat(5, 1fr)", gap: isXs ? 10 : 14, marginBottom: isXs ? 14 : 16 }}>
          {[1, 2, 3, 4, 5].map(i => (
            <div key={i} style={{ background: "#F9FAFB", borderRadius: 12, padding: "20px 18px", minHeight: 110, border: "0.8px solid #E5E7EB", display: "flex", flexDirection: "column", justifyContent: "space-between", gap: 10, boxSizing: "border-box" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <SkeletonBox width={32} height={32} borderRadius={8} />
                <SkeletonBox width={80} height={20} />
              </div>
              <SkeletonBox width="70%" height={12} />
            </div>
          ))}
        </div>

        {/* ── Collectable sub-row skeleton ── */}
        {expandCollectable && (
          <div style={{ display: "grid", gridTemplateColumns: isXs ? "1fr 1fr" : "repeat(auto-fill, minmax(280px, 1fr))", gap: isXs ? 10 : 12, marginBottom: isXs ? 14 : 16 }}>
            {[1, 2, 3, 4, 5, 6].map(i => (
              <div key={i} style={{ background: "#F9FAFB", borderRadius: 10, padding: "14px 12px", border: "0.8px solid #E5E7EB", display: "flex", flexDirection: "column", justifyContent: "space-between", minHeight: 95, boxSizing: "border-box" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <SkeletonBox width={24} height={24} borderRadius={6} />
                  <SkeletonBox width={60} height={16} />
                </div>
                <SkeletonBox width="80%" height={10} style={{ marginTop: 8 }} />
              </div>
            ))}
          </div>
        )}

        {/* ── CollectableToDate sub-row skeleton ── */}
        {expandCollectableToDate && (
          <div style={{ display: "grid", gridTemplateColumns: isXs ? "1fr 1fr" : "repeat(auto-fill, minmax(280px, 1fr))", gap: isXs ? 10 : 12, marginBottom: isXs ? 14 : 16 }}>
            {[1, 2, 3, 4, 5, 6].map(i => (
              <div key={i} style={{ background: "#F9FAFB", borderRadius: 10, padding: "14px 12px", border: "0.8px solid #E5E7EB", display: "flex", flexDirection: "column", justifyContent: "space-between", minHeight: 95, boxSizing: "border-box" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <SkeletonBox width={24} height={24} borderRadius={6} />
                  <SkeletonBox width={60} height={16} />
                </div>
                <SkeletonBox width="80%" height={10} style={{ marginTop: 8 }} />
              </div>
            ))}
          </div>
        )}

        {/* ── Collected sub-row skeleton ── */}
        {expandCollected && (
          <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginBottom: isXs ? 14 : 16 }}>
            {/* Large cards skeleton row */}
            <div style={{ display: "grid", gridTemplateColumns: isXs ? "1fr 1fr" : "repeat(2, 1fr)", gap: isXs ? 10 : 14 }}>
              {[1, 2].map(i => (
                <div key={i} style={{ background: "#F9FAFB", borderRadius: 12, padding: "20px 18px", minHeight: 110, border: "0.8px solid #E5E7EB", display: "flex", flexDirection: "column", justifyContent: "space-between", gap: 10, boxSizing: "border-box" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <SkeletonBox width={32} height={32} borderRadius={8} />
                    <SkeletonBox width={80} height={20} />
                  </div>
                  <SkeletonBox width="70%" height={12} />
                </div>
              ))}
            </div>
            {/* Small cards skeleton row */}
            <div style={{ display: "grid", gridTemplateColumns: isXs ? "1fr 1fr" : "repeat(auto-fill, minmax(280px, 1fr))", gap: isXs ? 10 : 12 }}>
              {[1, 2, 3, 4, 5, 6].map(i => (
                <div key={i} style={{ background: "#F9FAFB", borderRadius: 10, padding: "14px 12px", border: "0.8px solid #E5E7EB", display: "flex", flexDirection: "column", justifyContent: "space-between", minHeight: 95, boxSizing: "border-box" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <SkeletonBox width={24} height={24} borderRadius={6} />
                    <SkeletonBox width={60} height={16} />
                  </div>
                  <SkeletonBox width="80%" height={10} style={{ marginTop: 8 }} />
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ── Pending sub-row skeleton ── */}
        {expandPending && (
          <div style={{ display: "grid", gridTemplateColumns: isXs ? "1fr 1fr" : "repeat(auto-fill, minmax(280px, 1fr))", gap: isXs ? 10 : 12, marginBottom: isXs ? 14 : 16 }}>
            {[1, 2, 3, 4, 5, 6].map(i => (
              <div key={i} style={{ background: "#F9FAFB", borderRadius: 10, padding: "14px 12px", border: "0.8px solid #E5E7EB", display: "flex", flexDirection: "column", justifyContent: "space-between", minHeight: 95, boxSizing: "border-box" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <SkeletonBox width={24} height={24} borderRadius={6} />
                  <SkeletonBox width={60} height={16} />
                </div>
                <SkeletonBox width="80%" height={10} style={{ marginTop: 8 }} />
              </div>
            ))}
          </div>
        )}

        {/* ── Defaulted sub-row skeleton ── */}
        {expandDefaulted && (
          <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginBottom: isXs ? 14 : 16 }}>
            {/* Large cards skeleton row */}
            <div style={{ display: "grid", gridTemplateColumns: isXs ? "1fr 1fr" : "repeat(4, 1fr)", gap: isXs ? 10 : 14 }}>
              {[1, 2, 3, 4].map(i => (
                <div key={i} style={{ background: "#F9FAFB", borderRadius: 12, padding: "20px 18px", minHeight: 110, border: "0.8px solid #E5E7EB", display: "flex", flexDirection: "column", justifyContent: "space-between", gap: 10, boxSizing: "border-box" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <SkeletonBox width={32} height={32} borderRadius={8} />
                    <SkeletonBox width={80} height={20} />
                  </div>
                  <SkeletonBox width="70%" height={12} />
                </div>
              ))}
            </div>
            {/* Small cards skeleton row */}
            <div style={{ display: "grid", gridTemplateColumns: isXs ? "1fr 1fr" : "repeat(auto-fill, minmax(280px, 1fr))", gap: isXs ? 10 : 12 }}>
              {[1, 2, 3].map(i => (
                <div key={i} style={{ background: "#F9FAFB", borderRadius: 10, padding: "14px 12px", border: "0.8px solid #E5E7EB", display: "flex", flexDirection: "column", justifyContent: "space-between", minHeight: 95, boxSizing: "border-box" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <SkeletonBox width={24} height={24} borderRadius={6} />
                    <SkeletonBox width={60} height={16} />
                  </div>
                  <SkeletonBox width="80%" height={10} style={{ marginTop: 8 }} />
                </div>
              ))}
            </div>
          </div>
        )}

        <div style={{ display: "grid", gridTemplateColumns: isXs ? "1fr" : "1fr 1fr", gap: "14px", marginTop: 30 }}>
          {[1, 2].map(i => (
            <div key={i} style={{ background: "#F9FAFB", borderRadius: 12, padding: isXs ? "18px 16px" : "22px 24px", border: "0.8px solid #E5E7EB", display: "flex", flexDirection: "column", gap: 12 }}>
              <SkeletonBox width={120} height={14} />
              <SkeletonBox width={160} height={44} />
              <SkeletonBox width={100} height={12} />
            </div>
          ))}
        </div>
      </>
    );
  }
  // ─────────────────────────────────────────────────────────────────────────

  if (error) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px', color: '#E7000B', fontSize: '16px' }}>
        {error}
      </div>
    );
  }

  const isXs = w < 480;
  const isSm = w >= 480 && w < 768;
  const isMd = w >= 768 && w < 1024;
  const isLg = w >= 1024;
  const compact = isXs || isSm;
  const padding = isXs ? 16 : isSm ? 20 : isMd ? 24 : 32;
  const sectionPad = isXs ? "16px 16px" : isSm ? "18px 18px" : "24px 28px";
  const summaryBelow = isXs || isSm;
  const emiCardWidth = window.innerWidth > 1800 ? 300 : 260;

  const getTabStyle = (tab) => ({
    padding: "5px 14px", borderRadius: "16px",
    fontSize: window.innerWidth > 1800 ? "16px" : "14px", fontWeight: 500,
    transition: "all 0.2s ease",
    background: emiCardShow === tab ? "#fff" : "transparent",
    color: emiCardShow === tab ? "#111" : "#888",
    boxShadow: emiCardShow === tab ? "0 0 0 0.5px #d0d0d0" : "none",
  });

  const switchWrapperStyle = {
    display: "flex", alignItems: "center", border: "0.5px solid #d0d0d0",
    borderRadius: "20px", padding: "3px", cursor: "pointer",
    background: "#f5f5f5", flexShrink: 0, marginLeft: "24px", userSelect: "none",
  };

  const EMIS = emiData?.emiStages ? emiData.emiStages.map((stage, index) => {
    const accentColors = ["#3B82F6", "#10B981", "#F49F28", "#84CC16", "#0EA5E9", "#6366F1"];
    const badgeBgs = ["#3B82F61F", "#35A04F2B", "#F49F281F", "#F7FEE7", "#F0F9FF", "#EEF2FF"];
    const badgeColors = ["#3B82F6", "#327E45", "#EA580C", "#65A30D", "#0369A1", "#4338CA"];
    return {
      emi: stage?.emiSequence, cases: stage?.totalCases, month: stage?.month,
      amountOriginal: stage?.collectionAmount, amount: stage?.collectionAmountDisplay || 0,
      collectedamountOriginal: stage?.collectedAmount, collectedamount: stage?.collectedAmountDisplay || 0,
      collectableMonthToDate: stage?.collectableMonthToDate ?? null,
      collectableMonthToDateDisplay: stage?.collectableMonthToDateDisplay ?? null,
      breakdown: [
        { label: "Principal", value: stage?.principalDisplay || 0, originalValue: stage?.principal },
        { label: "Interest", value: stage?.interestDisplay || 0, originalValue: stage?.interest },
        { label: "Charges", value: stage?.chargesDisplay || 0, originalValue: stage?.charges },
      ],
      pct: `${stage?.portfolioPercentage?.toFixed(1)}%`,
      accentColor: accentColors[index % accentColors.length],
      badgeBg: badgeBgs[index % badgeBgs.length],
      badgeColor: badgeColors[index % badgeColors.length],
    };
  }) : [];

  const collectionEMIS = collectionBreakdownData?.months ? collectionBreakdownData.months.map((stage, index) => {
    const accentColors = ["#3B82F6", "#10B981", "#F49F28", "#84CC16", "#0EA5E9", "#6366F1"];
    const badgeBgs = ["#3B82F61F", "#35A04F2B", "#F49F281F", "#F7FEE7", "#F0F9FF", "#EEF2FF"];
    const badgeColors = ["#3B82F6", "#327E45", "#EA580C", "#65A30D", "#0369A1", "#4338CA"];
    return {
      emi: stage?.emiSequence, cases: stage?.totalCases, month: stage?.month,
      amountOriginal: stage?.expectedAmount, amount: stage?.expectedAmountDisplay || 0,
      collectedamountOriginal: stage?.collectedAmount, collectedamount: stage?.collectedAmountDisplay || 0,
      collectableMonthToDate: stage?.collectableMonthToDate ?? null,
      collectableMonthToDateDisplay: stage?.collectableMonthToDateDisplay ?? null,
      breakdown: [
        { label: "Principal", value: stage?.principalDisplay || 0, originalValue: stage?.principal },
        { label: "Interest", value: stage?.interestDisplay || 0, originalValue: stage?.interest },
        { label: "Charges", value: stage?.chargesDisplay || 0, originalValue: stage?.charges },
      ],
      pct: `${stage?.portfolioPercentage?.toFixed(1)}%`,
      accentColor: accentColors[index % accentColors.length],
      badgeBg: badgeBgs[index % badgeBgs.length],
      badgeColor: badgeColors[index % badgeColors.length],
      overdueAgingBuckets: stage?.overdueAgingBuckets ?? [],
    };
  }) : [];

  return (
    <React.Fragment>

      <style>{scrollbarStyles}</style>
      <div style={{ maxWidth: 2500, margin: "0 auto", padding, background: "#fff", boxSizing: "border-box", borderRadius: "16px", border: "1px solid rgb(226, 232, 240)", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", marginTop: "40px" }}>
        <div style={{ marginBottom: isXs ? 16 : 24, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
              <div style={{ width: 24, height: 24, borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <FileSpreadsheet color="#155DFC" />
              </div>
              <h1 style={{ margin: 0, fontSize: "clamp(15px, 2vw, 20px)", fontWeight: 600, color: "#101828", letterSpacing: "-0.3px" }}>Disbursal Tracking</h1>
            </div>
            <p style={{ margin: "8px 0", fontSize: "clamp(11px, 0.9vw, 14px)", color: "#6B7280", fontWeight: 400 }}>
              {selectedMonth?.length > 0 ? `Month: ${selectedMonth?.join(", ")}` : "No months selected"}
            </p>
          </div>
          <div>
            <button
              onClick={handleOpenCalculator}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                padding: "10px 18px",
                borderRadius: "10px",
                border: "1px solid #155DFC",
                backgroundColor: "transparent",
                color: "#155DFC",
                fontSize: "clamp(13px, 1.4vw, 15px)",
                fontWeight: "600",
                cursor: "pointer",
                transition: "all 0.15s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#155DFC";
                e.currentTarget.style.color = "#fff";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "transparent";
                e.currentTarget.style.color = "#155DFC";
              }}
            >
              <i className="fa fa-calculator" aria-hidden="true" style={{ fontSize: "14px" }}></i> Calculator
            </button>
          </div>
        </div>

        {/* ── Row 1: Disbursal stats ── */}
        {loadingDisbursal ? <DisbursalStatsSkeleton compact={compact} count={4} /> : (
          <div style={{ display: "flex", flexWrap: isLg ? "nowrap" : "wrap", gap: commonGap, marginBottom: commonMargin }}>
            <StatCard customId="0" Icon={IconUsers} iconColor="#155DFC" iconBg="#DBEAFE" value={currentData.stats?.totalCases} label="Total Cases Disbursed" cardBg="#EFF6FF" compact={compact} valueColor="#1C398E" Border="0.8px solid #DBEAFE" />
            <StatCard originalValue={currentData.stats?.amountDisbursedOriginal} Icon={IconDollar} iconColor="#00A63E" iconBg="#DCFCE7" value={currentData.stats?.amountDisbursed} label="Amount Disbursed" cardBg="#F0FDF4" compact={compact} valueColor="#0D542B" Border="0.8px solid #DCFCE7" />
            <StatCard originalValue={currentData.stats?.loansWithPF} Icon={IconCheckCircle} iconColor="#9810FA" iconBg="#F3E8FF" value={currentData.stats?.loansWithPFDISPALY} label="Loans with PF" cardBg="#FAF5FF" compact={compact} valueColor="#59168B" Border="0.8px solid #F3E8FF" />
            <StatCard originalValue={currentData.stats?.loansWithoutPF} Icon={IconCheckCircle} iconColor="#F54900" iconBg="#FFEDD4" value={currentData.stats?.loansWithoutPFDISPLAY} label="Loans without PF" cardBg="#FFF7ED" compact={compact} valueColor="#7E2A0C" Border="0.8px solid #FFEDD4" />
          </div>
        )}

        {/* ── Row 2: Fresh / Repeat stats ── */}
        {loadingDisbursal ? <DisbursalStatsSkeleton compact={compact} count={4} /> : (
          <div style={{ display: "flex", flexWrap: isLg ? "nowrap" : "wrap", gap: commonGap, marginBottom: commonMargin }}>
            <StatCard customId="0" Icon={IconUsers} iconColor="#C2410C" iconBg="#FFE4CC" value={currentData.stats?.freshCases} label="Fresh Cases" cardBg="#FFF4E6" compact={compact} valueColor="#C2410C" Border="0.8px solid #DBEAFE" />
            <StatCard originalValue={currentData.stats?.FreshAmountOrignal} Icon={IconDollar} iconColor="#B45309" iconBg="#FEF3C7" value={currentData.stats?.FreshAmount} label="Fresh Disbursement Amount" cardBg="#FFFBEB" compact={compact} valueColor="#B45309" Border="0.8px solid #DBEAFE" />
            <StatCard customId="0" Icon={IconUsers} iconColor="#BE123C" iconBg="#FFE4E6" value={currentData.stats?.RepeatCases} label="Repeat Cases" cardBg="#FFF1F2" compact={compact} valueColor="#BE123C" Border="0.8px solid #DCFCE7" />
            <StatCard originalValue={currentData.stats?.RepeatAmountOrignal} Icon={IconDollar} iconColor="#7C2D12" iconBg="#F5E6D8" value={currentData.stats?.RepeatAmount} label="Repeat Disbursement Amount" cardBg="#FDF6F0" compact={compact} valueColor="#7C2D12" Border="0.8px solid #DBEAFE" />
          </div>
        )}

        {/* ── Financial Breakdown ── */}
        {loadingDisbursal ? <FinancialBreakdownSkeleton isXs={isXs} /> : (
          <div style={{ background: "#F9FAFB", borderRadius: 16, padding: sectionPad, border: "0.8px solid #E5E7EB", marginBottom: commonMargin }}>
            <h6 style={{ margin: `0 0 ${isXs ? 12 : 18}px`, fontSize: "20px", fontWeight: 500, color: "#0A0A0A" }}>Financial Breakdown</h6>
            <div style={{ display: "flex", flexWrap: isXs ? "wrap" : "nowrap", gap: commonGap }}>
              <FinCard label="Principal" originalValue={currentData?.breakdown?.principalRepaidOriginal} value={currentData?.breakdown?.principalRepaid} pct={`${currentData?.breakdown?.principalPct}%`} compact={isXs} />
              <FinCard label="Interest" originalValue={currentData?.breakdown?.interestCollectedOriginal} value={currentData?.breakdown?.interestCollected} pct={`${currentData?.breakdown?.interestPct}%`} compact={isXs} />
              <FinCard label="Processing Fee Inclusive GST" originalValue={currentData?.breakdown?.outstandingOriginal} value={currentData?.breakdown?.processingFeeAmount} pct={`${currentData?.breakdown?.processingFeePct}%`} compact={isXs} />
            </div>
          </div>
        )}

        {/* ── EMI Breakdown ── */}
        <div style={{ background: "#F9FAFB", borderRadius: 16, padding: sectionPad, border: "0.8px solid #E5E7EB" }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
            <div>
              <h6 style={{ margin: `0 0 4px`, fontSize: "20px", fontWeight: 500, color: "#101828" }}>EMI Breakdown</h6>
              <p style={{ margin: `0 0 ${isXs ? 14 : 20}px`, fontSize: "14px", color: "#6A7282", fontWeight: "400" }}>Distribution of disbursed amount across upcoming EMI stages</p>
            </div>
            <div style={switchWrapperStyle}>
              <div style={getTabStyle("emi")} onClick={() => setemiCardShow("emi")}>EMI</div>
              <div style={getTabStyle("collection")} onClick={() => setemiCardShow("collection")}>Collection</div>
            </div>
          </div>

          {(loadingEmi && emiCardShow === "emi") || (loadingCollectionBreakdown && emiCardShow === "collection") ? (
            <EmiSectionSkeleton emiCardWidth={emiCardWidth} summaryWidth={window.innerWidth > 1800 ? 300 : 200} />
          ) : (
            <div className="emi-scroll" style={{ display: "flex", gap: commonGap, width: "100%", alignItems: "stretch", flexWrap: summaryBelow ? "wrap" : "nowrap" }}>
              <div style={{ flex: 1, minWidth: 0, overflowX: "auto", overflowY: "hidden", paddingBottom: 6 }} className="emi-scroll-container">
                <div style={{ display: "flex", gap: window.innerWidth > 1800 ? "20px" : '12px', width: "max-content" }}>
                  {emiCardShow === "emi" && EMIS.map((e, i) => (
                    <EmiCard key={i} {...e} cardWidth={emiCardWidth} onCardInfoClick={() => handleInfoPopup(e)} onMessageClick={() => setActiveEmi(e)} />
                  ))}
                  {emiCardShow === "collection" && collectionEMIS.map((e, i) => (
                    <EmiCard key={i} {...e} cardWidth={emiCardWidth} onCardInfoClick={() => handleInfoPopup(e)} onMessageClick={() => setActiveEmi(e)} />
                  ))}
                </div>
              </div>
              <div style={{ width: window.innerWidth > 1800 ? 300 : 200, flexShrink: 0, display: "flex", justifyContent: "flex-end" }}>
                <CollectionSummary
                  rate={currentData?.collection?.collectionRate ?? "0%"}
                  expected={currentData?.collection?.totalDue ?? "₹0.00L"}
                  expectedOriginal={currentData?.collection?.totalDueOriginal ?? 0}
                  collected={currentData?.collection?.totalCollected ?? "₹0.00L"}
                  collectedOriginal={currentData?.collection?.totalCollectedOriginal ?? 0}
                  gap={currentData?.collection?.collectionGap ?? "₹0.00L"}
                  gapOriginal={currentData?.collection?.collectionGapOriginal ?? 0}
                />
              </div>
            </div>
          )}
        </div>

        {activeEmi && (
          <Commentbox emiNo={activeEmi?.emi} month={activeEmi?.month} onClose={() => setActiveEmi(null)} comments={commentsData?.[activeEmi?.emi] || []} addComment={(comment) => addComment(activeEmi?.emi, comment)} />
        )}
        {tableListPopup && (
          <CustomPopupTable InfoActiveEmi={InfoActiveEmi} onClose={() => setTableListPopup(false)} currentFilterDate={currentFilterDate} emiCardShow={emiCardShow} nbfc={commonFilter?.nbfc} />
        )}

        {showCalculator && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(15, 23, 42, 0.45)",
              backdropFilter: "blur(4px)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
              padding: 20,
              animation: "backdropIn 0.2s ease",
            }}
            onClick={(e) => {
              if (e.target === e.currentTarget) setShowCalculator(false);
            }}
          >
            {
              loader ? <Loader /> : ""
            }
            <style>{`
              @keyframes backdropIn { from { opacity: 0; } to { opacity: 1; } }
              @keyframes modalIn { from { opacity: 0; transform: scale(0.95) translateY(12px); } to { opacity: 1; transform: scale(1) translateY(0); } }
            `}</style>
            <div
              style={{
                width: "100%",
                maxWidth: 600,
                background: "#ffffff",
                borderRadius: 20,
                padding: 28,
                boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
                animation: "modalIn 0.25s cubic-bezier(0.16, 1, 0.3, 1)",
                border: "1px solid #e2e8f0",
              }}
            >
              {/* Header */}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div style={{ width: 36, height: 36, borderRadius: "10px", background: "#EFF6FF", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <i className="fa fa-calculator" style={{ color: "#155DFC", fontSize: "18px" }}></i>
                  </div>
                  <div>
                    <h3 style={{ margin: 0, fontSize: "18px", fontWeight: 700, color: "#1e293b" }}>Disbursal Allocation Calculator</h3>
                    <p style={{ margin: 0, fontSize: "12px", color: "#64748b" }}>Simulate allocation ratios based on current month performance</p>
                  </div>
                </div>
                <button
                  onClick={() => setShowCalculator(false)}
                  style={{ background: "none", border: "none", cursor: "pointer", padding: 6, borderRadius: "50%", display: "flex", alignSelf: "flex-start" }}
                >
                  <i className="fa fa-times" style={{ color: "#94a3b8", fontSize: "18px" }}></i>
                </button>
              </div>

              {/* Input Form */}
              <div style={{ marginBottom: 24 }}>
                <label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: "#475569", marginBottom: 8 }}>
                  Amount Disbursed (Principal)
                </label>
                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                  <div style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    border: "1.5px solid #CBD5E1",
                    borderRadius: "10px",
                    background: "#F8FAFC",
                    overflow: "hidden",
                    transition: "all 0.2s",
                  }}>
                    <span style={{ padding: "0 12px", fontSize: "15px", color: "#64748b", fontWeight: "600" }}>₹</span>
                    <input
                      type="number"
                      placeholder="e.g. 3656000"
                      value={calcDisbursedInput}
                      onChange={(e) => {
                        const val = e.target.value;
                        setCalcDisbursedInput(val);
                      }}
                      style={{
                        flex: 1,
                        padding: "12px 12px 12px 0",
                        border: "none",
                        outline: "none",
                        background: "transparent",
                        fontSize: "15px",
                        fontWeight: "600",
                        color: "#1e293b",
                      }}
                    />
                  </div>
                  <button
                    onClick={() => runCalculation(calcDisbursedInput)}
                    style={{
                      padding: "12px 20px",
                      borderRadius: "10px",
                      background: "linear-gradient(135deg, #155DFC 0%, #0d46c1 100%)",
                      color: "#fff",
                      border: "none",
                      fontWeight: "600",
                      fontSize: "14px",
                      cursor: "pointer",
                      boxShadow: "0 4px 10px rgba(21, 93, 252, 0.3)",
                      transition: "transform 0.1s active",
                    }}
                  >
                    Calculate
                  </button>
                </div>
                {calcDisbursedInput && (
                  <div style={{ marginTop: 6, fontSize: "13px", color: "#155DFC", fontWeight: "600", paddingLeft: 4 }}>
                    Converted: {formatLakhs(calcDisbursedInput)} ({formatCurrency(calcDisbursedInput)})
                  </div>
                )}
              </div>

              {calcError && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 12,
                    background: "#FEF2F2",
                    border: "1px solid #FCA5A5",
                    borderRadius: 12,
                    padding: "14px 16px",
                    marginBottom: 20,
                    animation: "shake 0.3s ease-in-out",
                  }}
                >
                  <style>{`
                    @keyframes shake {
                      0%, 100% { transform: translateX(0); }
                      25% { transform: translateX(-4px); }
                      75% { transform: translateX(4px); }
                    }
                  `}</style>
                  <div style={{
                    width: 24,
                    height: 24,
                    borderRadius: "50%",
                    background: "#FEE2E2",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    marginTop: 1
                  }}>
                    <i className="fa fa-exclamation-triangle" style={{ color: "#EF4444", fontSize: "12px" }}></i>
                  </div>
                  <div style={{ flex: 1 }}>
                    <h5 style={{ margin: 0, fontSize: "13px", fontWeight: "700", color: "#991B1B" }}>Calculation Failed</h5>
                    <p style={{ margin: "4px 0 0", fontSize: "12px", color: "#B91C1C", fontWeight: "500", lineHeight: "1.4" }}>
                      {calcError}
                    </p>
                  </div>
                  <button
                    onClick={() => setCalcError(null)}
                    style={{ background: "none", border: "none", cursor: "pointer", padding: 4, display: "flex", alignSelf: "flex-start" }}
                  >
                    <i className="fa fa-times" style={{ color: "#FCA5A5", fontSize: "14px" }}></i>
                  </button>
                </div>
              )}

              {/* Ratios Info Text */}
              {/* {calcResults && (
                <div style={{ background: "#F1F5F9", borderRadius: "10px", padding: "10px 14px", marginBottom: 20, fontSize: "12px", color: "#475569" }}>
                  <i className="fa fa-info-circle" style={{ color: "#155DFC", marginRight: 6 }}></i>
                  Derived Ratios: Interest = <strong>{calcResults.interestRatio.toFixed(2)}%</strong> of Disbursed Amount | Processing Fee = <strong>{calcResults.processingFeeRatio.toFixed(2)}%</strong> of Disbursed Amount
                </div>
              )} */}

              {/* Results Breakdown Grid */}
              {calcResults ? (
                <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                  <h4 style={{ margin: "0 0 4px", fontSize: "14px", fontWeight: "600", color: "#1e293b" }}>
                    {calcDisbursedInput === "" || parseFloat(calcDisbursedInput) === parseFloat(currentData.stats?.amountDisbursedOriginal)
                      ? "Current Month Allocation Breakdown"
                      : "Simulated Allocation Breakdown"
                    }
                  </h4>

                  {/* Cards container */}
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>

                    {/* Principal */}
                    <div style={{ background: "#EFF6FF", border: "1px solid #bfdbfe", borderRadius: 12, padding: 14 }}>
                      <span style={{ fontSize: "11px", fontWeight: "600", color: "#1e40af", textTransform: "uppercase" }}>Principal</span>
                      <div style={{ fontSize: "16px", fontWeight: "700", color: "#1e40af", marginTop: 4 }}>
                        <StyledTooltip value={calcResults.principal} customStyle={{ cursor: "default" }}>
                          {calcResults.principalFormatted}
                        </StyledTooltip>
                      </div>
                      {/* <div style={{ fontSize: "11px", color: "#60a5fa", marginTop: 2 }}>{calcResults.principalPct}% of total</div> */}
                    </div>

                    {/* Interest */}
                    <div style={{ background: "#F0FDF4", border: "1px solid #bbf7d0", borderRadius: 12, padding: 14 }}>
                      <span style={{ fontSize: "11px", fontWeight: "600", color: "#166534", textTransform: "uppercase" }}>Interest</span>
                      <div style={{ fontSize: "16px", fontWeight: "700", color: "#166534", marginTop: 4 }}>
                        <StyledTooltip value={calcResults.interest} customStyle={{ cursor: "default" }}>
                          {calcResults.interestFormatted}
                        </StyledTooltip>
                      </div>
                      {/* <div style={{ fontSize: "11px", color: "#4ade80", marginTop: 2 }}>{calcResults.interestPct}% of total</div> */}
                    </div>

                    {/* Processing Fee */}
                    <div style={{ background: "#FAF5FF", border: "1px solid #e9d5ff", borderRadius: 12, padding: 14 }}>
                      <span style={{ fontSize: "11px", fontWeight: "600", color: "#6b21a8", textTransform: "uppercase" }}>Proc. Fee Exclusive GST</span>
                      <div style={{ fontSize: "16px", fontWeight: "700", color: "#6b21a8", marginTop: 4 }}>
                        <StyledTooltip value={calcResults.processingFee} customStyle={{ cursor: "default" }}>
                          {calcResults.processingFeeFormatted}
                        </StyledTooltip>
                      </div>
                      {/* <div style={{ fontSize: "11px", color: "#c084fc", marginTop: 2 }}>{calcResults.processingFeePct}% of total</div> */}
                    </div>

                  </div>

                  {/* Summary / Total Card */}
                  <div style={{
                    background: "linear-gradient(135deg, #155DFC 0%, #0d46c1 100%)",
                    borderRadius: 12,
                    padding: 16,
                    color: "#fff",
                    marginTop: 8,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    boxShadow: "0 4px 12px rgba(21, 93, 252, 0.25)"
                  }}>
                    <div>
                      <span style={{ fontSize: "11px", color: "#DBEAFE", textTransform: "uppercase", fontWeight: "600" }}>TOTAL INCOME</span>
                      <div style={{ fontSize: "20px", fontWeight: "700", marginTop: 2 }}>
                        <StyledTooltip value={(calcResults.interest || 0) + (calcResults.processingFee || 0)} customStyle={{ cursor: "default" }}>
                          {formatCalcValue((calcResults.interest || 0) + (calcResults.processingFee || 0))}
                        </StyledTooltip>
                      </div>
                    </div>
                    <div style={{ textAlign: "right", fontSize: "12px", color: "#EFF6FF" }}>
                      Raw Sum: {formatCurrency((calcResults.interest || 0) + (calcResults.processingFee || 0))}
                    </div>
                  </div>

                </div>
              ) : (
                <div style={{ padding: "40px 0", textAlign: "center", color: "#94a3b8", fontSize: "14px", border: "1.5px dashed #cbd5e1", borderRadius: "12px" }}>
                  <i className="fa fa-calculator" style={{ fontSize: "24px", marginBottom: 10, display: "block" }}></i>
                  Enter a valid disbursal amount to see calculations
                </div>
              )}

              {/* Footer Actions */}
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 28, borderTop: "1px solid #e2e8f0", paddingTop: 18 }}>
                <button
                  onClick={() => {
                    setCalcDisbursedInput("");
                    setCalcResults(getDefaultCalcResults());
                  }}
                  style={{
                    padding: "9px 18px",
                    borderRadius: "10px",
                    background: "#F1F5F9",
                    border: "1px solid #E2E8F0",
                    fontWeight: "600",
                    color: "#475569",
                    cursor: "pointer",
                    fontSize: "13px",
                  }}
                >
                  Reset
                </button>
                <button
                  onClick={() => setShowCalculator(false)}
                  style={{
                    padding: "9px 18px",
                    borderRadius: "10px",
                    background: "linear-gradient(135deg, #155DFC 0%, #0d46c1 100%)",
                    border: "none",
                    fontWeight: "600",
                    color: "#fff",
                    cursor: "pointer",
                    fontSize: "13px",
                    boxShadow: "0 2px 6px rgba(21, 93, 252, 0.2)"
                  }}
                >
                  Close
                </button>
              </div>

            </div>
          </div>
        )}
      </div>

      {/* ── Collection Summary section ── */}
      <div style={{ background: "#fff", borderRadius: 16, padding: sectionPad, border: "1px solid #E5E7EB", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", margin: "20px auto", maxWidth: 2500, marginTop: commonMargin }}>
        <div style={{ marginBottom: isXs ? 16 : 20 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
            <div style={{ width: 20, height: 20, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="12" y1="1" x2="12" y2="23" />
                <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
              </svg>
            </div>
            <h2 style={{ margin: 0, fontSize: "20px", fontWeight: 600, color: "#101828" }}>Collection Summary</h2>
          </div>
          <p style={{ margin: "8px 0", fontSize: "14px", color: "#6A7282", fontWeight: "400" }}>
            {selectedMonth?.length > 0 ? `Month: ${selectedMonth?.join(", ")}` : "No months selected"}
          </p>
        </div>

        {loadingCollectionSummary ? <CollectionStatsSkeleton isXs={isXs} /> : (
          <>
            <div style={{ display: "grid", gridTemplateColumns: isXs ? "1fr 1fr" : "repeat(5, 1fr)", gap: isXs ? 10 : 14, marginBottom: isXs ? 14 : 16 }}>
              {[
                { bg: "#EFF6FF", Border: "0.8px solid #DBEAFE", iconBg: "#DBEAFE", iconColor: "#3B82F6", valueColor: "#1E40AF", value: currentData.collection?.totalDue ?? "₹0.00L", originalValue: currentData.collection?.totalDueOriginal ?? 0, label: "Total Collectable Amount", customInfo: "Total EMI of loans disbursed in selected range", clickable: true, toggleFn: () => {setExpandCollectable(v => !v); setExpandCollectableToDate(false); setExpandCollected(false); setExpandDefaulted(false); setExpandPending(false);}, expanded: expandCollectable, listTab: "TOTAL_COLLECTABLE",
                  icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg> },
                { bg: "rgb(250,245,255)", Border: "0.8px solid rgb(243,232,255)", iconBg: "rgb(243,232,255)", iconColor: "#59168b", valueColor: "rgb(89,22,139)", value: currentData.collection?.totalCollectedTillDate ?? "₹0.00L", originalValue: currentData.collection?.totalCollectedOriginalTillDate ?? 0, label: "Total Collectable Amount (By Today + Foreclosure)", customInfo: "EMI due till today from those loans", clickable: true, toggleFn: () => {setExpandCollectableToDate(v => !v); setExpandCollectable(false); setExpandCollected(false); setExpandDefaulted(false); setExpandPending(false);}, expanded: expandCollectableToDate,
                  icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#59168b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12V7H5a2 2 0 0 1 0-4h14v4" /><path d="M3 5v14a2 2 0 0 0 2 2h16v-5" /><path d="M18 12a2 2 0 0 0 0 4h4v-4Z" /></svg> },
                { bg: "rgb(250,245,255)", Border: "0.8px solid rgb(243,232,255)", iconBg: "rgb(243,232,255)", iconColor: "#59168b", valueColor: "rgb(89,22,139)", value: currentData.collection?.totalCollected ?? "₹0", originalValue: currentData.collection?.totalCollectedOriginal ?? 0, label: "Total Collected Amount", customInfo: "Till Date + Foreclose Amount", clickable: true, toggleFn: () => {setExpandCollected(v => !v); setExpandCollectable(false); setExpandCollectableToDate(false); setExpandDefaulted(false); setExpandPending(false);}, expanded: expandCollected,
                  icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#59168b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12V7H5a2 2 0 0 1 0-4h14v4" /><path d="M3 5v14a2 2 0 0 0 2 2h16v-5" /><path d="M18 12a2 2 0 0 0 0 4h4v-4Z" /></svg> },
                { bg: "#FFFBEB", Border: "0.8px solid #FEF9C2", iconBg: "#FEF3C7", iconColor: "#F59E0B", valueColor: "#92400E", value: currentData.collection?.pending ?? "₹0", originalValue: currentData.collection?.pendingOriginal ?? 0, label: "Pending Amount", customInfo: "Overdue + upcoming EMIs", clickable: true, toggleFn: () => {setExpandPending(v => !v); setExpandCollectable(false); setExpandCollectableToDate(false); setExpandCollected(false); setExpandDefaulted(false);}, expanded: expandPending, listTab: "PENDING",
                  icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#F59E0B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg> },
                { bg: "#FEF2F2", Border: "0.8px solid #FFE2E2", iconBg: "#FEE2E2", iconColor: "#EF4444", valueColor: "#991B1B", value: currentData.collection?.defaulted ?? "₹0", originalValue: currentData.collection?.defaultedOriginal ?? 0, label: "Total Defaulted EMI Amount", customInfo: "Total EMIs Amount", clickable: true, toggleFn: () => {setExpandDefaulted(v => !v); setExpandCollected(false); setExpandCollectable(false); setExpandCollectableToDate(false); setExpandPending(false);}, expanded: expandDefaulted, listTab: "OVERDUE",
                  icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg> },
              ].map(({ bg, iconBg, icon, valueColor, value, label, Border, originalValue, customInfo, clickable, toggleFn, expanded, listTab }) => (
                <div
                  key={label}
                  onClick={clickable ? toggleFn : undefined}
                  style={{ background: bg, borderRadius: 12, padding: "20px 18px", display: "flex", flexDirection: "column", justifyContent: "space-between", minHeight: 110, border: Border, cursor: clickable ? "pointer" : "default", position: "relative" }}
                  onMouseEnter={e => { if (clickable) e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.08)"; }}
                  onMouseLeave={e => { if (clickable) e.currentTarget.style.boxShadow = "none"; }}
                >
                  {clickable && (
                    <div style={{ position: "absolute", top: 8, right: 10, opacity: 0.5 }}>
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={valueColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
                        style={{ transform: expanded ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s", display: "block" }}>
                        <polyline points="6 9 12 15 18 9" />
                      </svg>
                    </div>
                  )}
                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <div style={{ width: 32, height: 32, borderRadius: 8, background: iconBg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>{icon}</div>
                    <StyledTooltip value={originalValue}>
                      <span style={{ fontSize: "clamp(16px, 2vw, 20px)", fontWeight: 700, color: valueColor, letterSpacing: "-0.5px", lineHeight: 1 }}>{value}</span>
                    </StyledTooltip>
                  </div>
                  <p style={{ margin: "12px 0 0", fontSize: "clamp(11px, 0.9vw, 13px)", fontWeight: 400, color: "#64748B", display: 'flex', gap: '5px', alignItems: 'center', width: '100%' }}>
                    <span>{label}</span>
                    {customInfo !== "" && <CustomTooltip title={customInfo || 'NA'}><InfoOutlinedIcon /></CustomTooltip>}
                    {listTab && (
                      <span
                        onClick={(e) => {
                          e.stopPropagation();
                          setCollectionPopupTab(listTab);
                        }}
                        style={{
                          marginLeft: "auto",
                          cursor: "pointer",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: valueColor,
                          padding: "4px",
                          borderRadius: "6px",
                          background: "rgba(255, 255, 255, 0.65)",
                          border: "0.5px solid rgba(0, 0, 0, 0.08)",
                          transition: "background 0.15s"
                        }}
                        onMouseEnter={e => e.currentTarget.style.background = "#ffffff"}
                        onMouseLeave={e => e.currentTarget.style.background = "rgba(255, 255, 255, 0.65)"}
                        title={`View ${label} Details`}
                      >
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: 'auto' }}>
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                          <circle cx="12" cy="12" r="3" />
                        </svg>
                      </span>
                    )}
                    {/* {label === "Total Defaulted EMI Amount" && (
                      <span
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowPtpModal(true);
                        }}
                        style={{
                          marginLeft: "6px",
                          cursor: "pointer",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: valueColor,
                          padding: "3px 8px",
                          borderRadius: "6px",
                          background: "rgba(255, 255, 255, 0.65)",
                          border: "0.5px solid rgba(0, 0, 0, 0.08)",
                          fontSize: "11px",
                          fontWeight: "700",
                          transition: "all 0.15s"
                        }}
                        onMouseEnter={e => {
                          e.currentTarget.style.background = valueColor;
                          e.currentTarget.style.color = "#ffffff";
                        }}
                        onMouseLeave={e => {
                          e.currentTarget.style.background = "rgba(255, 255, 255, 0.65)";
                          e.currentTarget.style.color = valueColor;
                        }}
                        title="Set Promise to Pay (PTP)"
                      >
                        PTP
                      </span>
                    )} */}
                  </p>

                  {/* Tooltip Popup for Total Collectable Amount (Commented out for reference)
                  {expanded && label === "Total Collectable Amount" && (
                    <>
                      <div 
                        style={{
                          position: "fixed",
                          inset: 0,
                          background: "transparent",
                          zIndex: 1090
                        }} 
                        onClick={(e) => {
                          e.stopPropagation();
                          setExpandCollectable(false);
                        }}
                      />
                      <div 
                        style={{
                          position: "absolute",
                          top: "calc(100% + 8px)",
                          left: isXs ? "-10px" : "0px",
                          background: "#ffffff",
                          borderRadius: "12px",
                          border: "1px solid #E2E8F0",
                          width: "320px",
                          boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                          padding: "16px",
                          display: "flex",
                          flexDirection: "column",
                          gap: "12px",
                          zIndex: 1100,
                          cursor: "default",
                          animation: "scaleIn 0.15s ease-out"
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          <span style={{ fontSize: "13px", fontWeight: 700, color: "#0F172A", fontFamily: FONT }}>Collectable Breakdown</span>
                          <span 
                            onClick={() => setExpandCollectable(false)}
                            style={{ fontSize: "16px", fontWeight: "600", color: "#94A3B8", cursor: "pointer", display: "flex", alignItems: "center" }}
                          >
                            &times;
                          </span>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                          {[
                            { bg: "#EFF6FF", Border: "0.8px solid #BFDBFE", iconBg: "#DBEAFE", iconColor: "#3B82F6", valueColor: "#1E40AF", value: currentData.collection?.collectablePrincipalDisplay ?? "₹0", originalValue: currentData.collection?.collectablePrincipal ?? 0, label: "Principal Amount", customInfo: "Principal portion of collectable EMIs", icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" /><line x1="12" y1="8" x2="12.01" y2="8" /></svg> },
                            { bg: "#F0FDF4", Border: "0.8px solid #BBF7D0", iconBg: "#DCFCE7", iconColor: "#22C55E", valueColor: "#15803D", value: currentData.collection?.collectableInterestDisplay ?? "₹0", originalValue: currentData.collection?.collectableInterest ?? 0, label: "Interest Amount", customInfo: "Interest portion of collectable EMIs", icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#22C55E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" /><line x1="12" y1="8" x2="12.01" y2="8" /></svg> },
                            { bg: "#FFF7ED", Border: "0.8px solid #FFEDD5", iconBg: "#FFEDD5", iconColor: "#F97316", valueColor: "#C2410C", value: currentData.collection?.collectableOverdueInterestDisplay ?? "₹0", originalValue: currentData.collection?.collectableOverdueInterest ?? 0, label: "Overdue Interest", customInfo: "Accumulated overdue interest", icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#F97316" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /></svg> },
                            { bg: "#FEF2F2", Border: "0.8px solid #FEE2E2", iconBg: "#FEE2E2", iconColor: "#EF4444", valueColor: "#B91C1C", value: currentData.collection?.collectablePenaltyDisplay ?? "₹0", originalValue: currentData.collection?.collectablePenalty ?? 0, label: "Penalty Amount", customInfo: "Accumulated penalty charges", icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg> },
                            { bg: "#FAF5FF", Border: "0.8px solid #F3E8FF", iconBg: "#F3E8FF", iconColor: "#A855F7", valueColor: "#7E22CE", value: currentData.collection?.collectableBounceDisplay ?? "₹0", originalValue: currentData.collection?.collectableBounce ?? 0, label: "Bounce Charges", customInfo: "Total bounce charges", icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#A855F7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m15 9-6 6" /><path d="m9 9 6 6" /></svg> },
                            { bg: "#F8FAFC", Border: "0.8px solid #E2E8F0", iconBg: "#F1F5F9", iconColor: "#64748B", valueColor: "#334155", value: currentData.collection?.collectableWaivedDisplay ?? "₹0", originalValue: currentData.collection?.collectableWaived ?? 0, label: "Waived Amount", customInfo: "Total waived amount", icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#64748B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14" /></svg> },
                          ].map(({ bg, iconBg, icon, valueColor, value, label, Border, originalValue, customInfo }) => (
                            <div key={label} style={{ background: bg, borderRadius: 8, padding: "10px 12px", border: Border, display: "flex", alignItems: "center", gap: "8px" }}>
                              <div style={{ width: 24, height: 24, borderRadius: 6, background: iconBg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>{icon}</div>
                              <div style={{ display: "flex", flexDirection: "column" }}>
                                <span style={{ fontSize: "10px", color: "#64748B", fontWeight: 500, display: 'flex', gap: '3px', alignItems: 'center', fontFamily: FONT }}>
                                  {label}
                                  {customInfo !== "" && <CustomTooltip title={customInfo || 'NA'}><InfoOutlinedIcon style={{ fontSize: "11px" }} /></CustomTooltip>}
                                </span>
                                <StyledTooltip value={originalValue}>
                                  <span style={{ fontSize: "13px", fontWeight: 700, color: valueColor, fontFamily: FONT }}>{value}</span>
                                </StyledTooltip>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </>
                  )}
                  */}

                  {/* Tooltip Popup for Collected Amount (Commented out for reference)
                  {expanded && label === "Total Collected Amount" && (
                    <>
                      <div 
                        style={{
                          position: "fixed",
                          inset: 0,
                          background: "transparent",
                          zIndex: 1090
                        }} 
                        onClick={(e) => {
                          e.stopPropagation();
                          setExpandCollected(false);
                        }}
                      />
                      <div 
                        style={{
                          position: "absolute",
                          bottom: "calc(100% + 8px)",
                          right: isXs ? "-20px" : "0px",
                          background: "#ffffff",
                          borderRadius: "12px",
                          border: "1px solid #E2E8F0",
                          width: "320px",
                          boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                          padding: "16px",
                          display: "flex",
                          flexDirection: "column",
                          gap: "12px",
                          zIndex: 1100,
                          cursor: "default",
                          animation: "scaleIn 0.15s ease-out"
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          <span style={{ fontSize: "13px", fontWeight: 700, color: "#0F172A", fontFamily: FONT }}>Collected Breakdown</span>
                          <span 
                            onClick={() => setExpandCollected(false)}
                            style={{ fontSize: "16px", fontWeight: "600", color: "#94A3B8", cursor: "pointer", display: "flex", alignItems: "center" }}
                          >
                            &times;
                          </span>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                          {[
                            { bg: "#ECFDF5", Border: "0.8px solid #DCFCE7", iconBg: "#D1FAE5", iconColor: "#10B981", valueColor: "#047857", value: currentData.collection?.totalCollectedPastDueDisplay ?? "₹0", originalValue: currentData.collection?.totalCollectedPastDue ?? 0, label: "Collected Till Date", customInfo: "Total EMIs Paid", listTab: "COLLECTED", icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" /></svg> },
                            { bg: "#EEF2FF", Border: "0.8px solid #E0E7FF", iconBg: "#E0E7FF", iconColor: "#6366F1", valueColor: "#3730A3", value: currentData.collection?.totalCollectedFutureDueDisplay ?? "₹0", originalValue: currentData.collection?.totalCollectedFutureDue ?? 0, label: "Foreclosure Amount", customInfo: "Total EMIs Paid", listTab: "FORECLOSURE", icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" /></svg> },
                          ].map(({ bg, iconBg, icon, valueColor, value, label, Border, originalValue, customInfo, listTab }) => (
                            <div key={label} style={{ background: bg, borderRadius: 8, padding: "10px 12px", border: Border, display: "flex", alignItems: "center", justifyContent: "space-between", gap: "6px" }}>
                              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <div style={{ width: 24, height: 24, borderRadius: 6, background: iconBg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>{icon}</div>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                  <span style={{ fontSize: "10px", color: "#64748B", fontWeight: 500, display: "flex", alignItems: "center", gap: "3px", fontFamily: FONT }}>
                                    {label}
                                    {customInfo !== "" && <CustomTooltip title={customInfo || 'NA'}><InfoOutlinedIcon style={{ fontSize: "11px" }} /></CustomTooltip>}
                                  </span>
                                  <StyledTooltip value={originalValue}>
                                    <span style={{ fontSize: "13px", fontWeight: 700, color: valueColor, fontFamily: FONT }}>{value}</span>
                                  </StyledTooltip>
                                </div>
                              </div>
                              {listTab && (
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setCollectionPopupTab(listTab);
                                    setExpandCollected(false);
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: valueColor,
                                    padding: "4px",
                                    borderRadius: "4px",
                                    background: "#ffffff",
                                    border: "1px solid rgba(0, 0, 0, 0.08)"
                                  }}
                                  title={`View ${label} Details`}
                                >
                                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                    <circle cx="12" cy="12" r="3" />
                                  </svg>
                                </span>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    </>
                  )}
                  */}

                  {/* Tooltip Popup for Defaulted Amount (Commented out for reference)
                  {expanded && label === "Total Defaulted EMI Amount" && (
                    <>
                      <div 
                        style={{
                          position: "fixed",
                          inset: 0,
                          background: "transparent",
                          zIndex: 1090
                        }} 
                        onClick={(e) => {
                          e.stopPropagation();
                          setExpandDefaulted(false);
                        }}
                      />
                      <div 
                        style={{
                          position: "absolute",
                          bottom: "calc(100% + 8px)",
                          right: isXs ? "-20px" : "0px",
                          background: "#ffffff",
                          borderRadius: "12px",
                          border: "1px solid #E2E8F0",
                          width: "320px",
                          boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                          padding: "16px",
                          display: "flex",
                          flexDirection: "column",
                          gap: "12px",
                          zIndex: 1100,
                          cursor: "default",
                          animation: "scaleIn 0.15s ease-out"
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          <span style={{ fontSize: "13px", fontWeight: 700, color: "#0F172A", fontFamily: FONT }}>Defaulted Breakdown</span>
                          <span 
                            onClick={() => setExpandDefaulted(false)}
                            style={{ fontSize: "16px", fontWeight: "600", color: "#94A3B8", cursor: "pointer", display: "flex", alignItems: "center" }}
                          >
                            &times;
                          </span>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                          {[
                            { bg: "#FFF7ED", Border: "0.8px solid #FED7AA", iconBg: "#FFEDD5", iconColor: "#EA580C", valueColor: "#9A3412", value: currentData.collection?.collectionGap ?? "₹0.00L", originalValue: currentData.collection?.collectionGapOriginal ?? 0, label: "Total Overdue Amount", customInfo: "Total Overdue Amount", icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#EA580C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" /></svg> },
                            { bg: "#FFF7ED", Border: "0.8px solid #FED7AA", iconBg: "#FFEDD5", iconColor: "#EA580C", valueColor: "#9A3412", value: currentData.collection?.defaultedOverdueInterest ?? "₹0.00L", originalValue: currentData.collection?.defaultedOverdueInterestOriginal ?? 0, label: "Defaulted Overdue Interest Amount", customInfo: "Total Overdue Interest", icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#EA580C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" /></svg> },
                            { bg: "#FEF2F2", Border: "0.8px solid #FECACA", iconBg: "#FEE2E2", iconColor: "#DC2626", valueColor: "#991B1B", value: currentData.collection?.defaultedPenalty ?? "₹0.00L", originalValue: currentData.collection?.defaultedPenaltyOriginal ?? 0, label: "Defaulted Penalty Amount", customInfo: "Total Penalty Amount", icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#DC2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg> },
                            { bg: "#FDF4FF", Border: "0.8px solid #F3E8FF", iconBg: "#F3E8FF", iconColor: "#9333EA", valueColor: "#6B21A8", value: currentData.collection?.defaultedBounce ?? "₹0.00L", originalValue: currentData.collection?.defaultedBounceOriginal ?? 0, label: "Defaulted Bounce Charges", customInfo: "Total Bounce Charges", icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9333EA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10" /><path d="m15 9-6 6" /><path d="m9 9 6 6" /><path d="M19 16v6" /><path d="M22 19h-6" /></svg> },
                          ].map(({ bg, iconBg, icon, valueColor, value, label, Border, originalValue, customInfo }) => (
                            <div key={label} style={{ background: bg, borderRadius: 8, padding: "10px 12px", border: Border, display: "flex", alignItems: "center", gap: "8px" }}>
                              <div style={{ width: 24, height: 24, borderRadius: 6, background: iconBg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>{icon}</div>
                              <div style={{ display: "flex", flexDirection: "column" }}>
                                <span style={{ fontSize: "10px", color: "#64748B", fontWeight: 500, display: 'flex', gap: '3px', alignItems: 'center', fontFamily: FONT }}>
                                  {label}
                                  {customInfo !== "" && <CustomTooltip title={customInfo || 'NA'}><InfoOutlinedIcon style={{ fontSize: "11px" }} /></CustomTooltip>}
                                </span>
                                <StyledTooltip value={originalValue}>
                                  <span style={{ fontSize: "13px", fontWeight: 700, color: valueColor, fontFamily: FONT }}>{value}</span>
                                </StyledTooltip>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </>
                  )}
                  */}
                </div>
              ))}
            </div>

            {/* ── Collectable sub-row: expands when blue card is clicked ── */}
            <div style={{
              maxHeight: expandCollectable ? "300px" : "0px",
              opacity: expandCollectable ? 1 : 0,
              overflow: "hidden",
              marginBottom: expandCollectable ? 16 : 0,
              transition: "max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1), margin-bottom 0.4s cubic-bezier(0.4, 0, 0.2, 1)"
            }}>
              <div style={{ display: "grid", gridTemplateColumns: isXs ? "1fr 1fr" : "repeat(auto-fill, minmax(280px, 1fr))", gap: isXs ? 10 : 12, paddingBottom: 4 }}>
                {[
                  { bg: "#EFF6FF", Border: "0.8px solid #BFDBFE", iconBg: "#DBEAFE", iconColor: "#3B82F6", valueColor: "#1E40AF", value: currentData.collection?.collectablePrincipalDisplay ?? "₹0", originalValue: currentData.collection?.collectablePrincipal ?? 0, label: "Principal Amount", customInfo: "Principal portion of collectable EMIs", icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" /><line x1="12" y1="8" x2="12.01" y2="8" /></svg> },
                  { bg: "#F0FDF4", Border: "0.8px solid #BBF7D0", iconBg: "#DCFCE7", iconColor: "#22C55E", valueColor: "#15803D", value: currentData.collection?.collectableInterestDisplay ?? "₹0", originalValue: currentData.collection?.collectableInterest ?? 0, label: "Interest Amount", customInfo: "Interest portion of collectable EMIs", icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#22C55E" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" /><line x1="12" y1="8" x2="12.01" y2="8" /></svg> },
                  { bg: "#FFF7ED", Border: "0.8px solid #FFEDD5", iconBg: "#FFEDD5", iconColor: "#F97316", valueColor: "#C2410C", value: currentData.collection?.collectableOverdueInterestDisplay ?? "₹0", originalValue: currentData.collection?.collectableOverdueInterest ?? 0, label: "Overdue Interest", customInfo: "Accumulated overdue interest", icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#F97316" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /></svg> },
                  { bg: "#FEF2F2", Border: "0.8px solid #FEE2E2", iconBg: "#FEE2E2", iconColor: "#EF4444", valueColor: "#B91C1C", value: currentData.collection?.collectablePenaltyDisplay ?? "₹0", originalValue: currentData.collection?.collectablePenalty ?? 0, label: "Penalty Amount", customInfo: "Accumulated penalty charges", icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#EF4444" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg> },
                  { bg: "#FAF5FF", Border: "0.8px solid #F3E8FF", iconBg: "#F3E8FF", iconColor: "#A855F7", valueColor: "#7E22CE", value: currentData.collection?.collectableBounceDisplay ?? "₹0", originalValue: currentData.collection?.collectableBounce ?? 0, label: "Bounce Charges", customInfo: "Total bounce charges", icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#A855F7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m15 9-6 6" /><path d="m9 9 6 6" /></svg> },
                  { bg: "#F8FAFC", Border: "0.8px solid #E2E8F0", iconBg: "#F1F5F9", iconColor: "#64748B", valueColor: "#334155", value: currentData.collection?.collectableWaivedDisplay ?? "₹0", originalValue: currentData.collection?.collectableWaived ?? 0, label: "Waived Amount", customInfo: "Total waived amount", icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#64748B" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14" /></svg> },
                ].map(({ bg, iconBg, icon, valueColor, value, label, Border, originalValue, customInfo }) => (
                  <div key={label} style={{ background: bg, borderRadius: 10, padding: "14px 12px", display: "flex", flexDirection: "column", justifyContent: "space-between", minHeight: 95, border: Border, boxSizing: "border-box" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <div style={{ width: 24, height: 24, borderRadius: 6, background: iconBg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>{icon}</div>
                      <StyledTooltip value={originalValue}>
                        <span style={{ fontSize: "16px", fontWeight: 700, color: valueColor, fontFamily: FONT }}>{value}</span>
                      </StyledTooltip>
                    </div>
                    <p style={{ margin: "8px 0 0", fontSize: "11px", fontWeight: 500, color: "#64748B", display: "flex", gap: "3px", alignItems: "center", fontFamily: FONT }}>
                      <span>{label}</span>
                      {customInfo !== "" && <CustomTooltip title={customInfo || 'NA'}><InfoOutlinedIcon style={{ fontSize: "12px" }} /></CustomTooltip>}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            {/* ── CollectableToDate sub-row: expands when blue card (By Today + Foreclosure) is clicked ── */}
            <div style={{
              maxHeight: expandCollectableToDate ? "300px" : "0px",
              opacity: expandCollectableToDate ? 1 : 0,
              overflow: "hidden",
              marginBottom: expandCollectableToDate ? 16 : 0,
              transition: "max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1), margin-bottom 0.4s cubic-bezier(0.4, 0, 0.2, 1)"
            }}>
              <div style={{ display: "grid", gridTemplateColumns: isXs ? "1fr 1fr" : "repeat(auto-fill, minmax(280px, 1fr))", gap: isXs ? 10 : 12, paddingBottom: 4 }}>
                {[
                  { bg: "#EFF6FF", Border: "0.8px solid #BFDBFE", iconBg: "#DBEAFE", iconColor: "#3B82F6", valueColor: "#1E40AF", value: currentData.collection?.collectableToDatePrincipalDisplay ?? "₹0.00", originalValue: currentData.collection?.collectableToDatePrincipal ?? 0, label: "Principal Amount", customInfo: "Principal portion of collectable EMIs till date", icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" /><line x1="12" y1="8" x2="12.01" y2="8" /></svg> },
                  { bg: "#F0FDF4", Border: "0.8px solid #BBF7D0", iconBg: "#DCFCE7", iconColor: "#22C55E", valueColor: "#15803D", value: currentData.collection?.collectableToDateInterestDisplay ?? "₹0.00", originalValue: currentData.collection?.collectableToDateInterest ?? 0, label: "Interest Amount", customInfo: "Interest portion of collectable EMIs till date", icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#22C55E" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" /><line x1="12" y1="8" x2="12.01" y2="8" /></svg> },
                  { bg: "#FFF7ED", Border: "0.8px solid #FFEDD5", iconBg: "#FFEDD5", iconColor: "#F97316", valueColor: "#C2410C", value: currentData.collection?.collectableToDateOverdueInterestDisplay ?? "₹0.00", originalValue: currentData.collection?.collectableToDateOverdueInterest ?? 0, label: "Overdue Interest", customInfo: "Accumulated overdue interest till date", icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#F97316" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /></svg> },
                  { bg: "#FEF2F2", Border: "0.8px solid #FEE2E2", iconBg: "#FEE2E2", iconColor: "#EF4444", valueColor: "#B91C1C", value: currentData.collection?.collectableToDatePenaltyDisplay ?? "₹0.00", originalValue: currentData.collection?.collectableToDatePenalty ?? 0, label: "Penalty Amount", customInfo: "Accumulated penalty charges till date", icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#EF4444" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg> },
                  { bg: "#FAF5FF", Border: "0.8px solid #F3E8FF", iconBg: "#F3E8FF", iconColor: "#A855F7", valueColor: "#7E22CE", value: currentData.collection?.collectableToDateBounceDisplay ?? "₹0.00", originalValue: currentData.collection?.collectableToDateBounce ?? 0, label: "Bounce Charges", customInfo: "Total bounce charges till date", icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#A855F7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m15 9-6 6" /><path d="m9 9 6 6" /></svg> },
                  { bg: "#F8FAFC", Border: "0.8px solid #E2E8F0", iconBg: "#F1F5F9", iconColor: "#64748B", valueColor: "#334155", value: currentData.collection?.collectableToDateWaivedDisplay ?? "₹0.00", originalValue: currentData.collection?.collectableToDateWaived ?? 0, label: "Waived Amount", customInfo: "Total waived amount till date", icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#64748B" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14" /></svg> },
                ].map(({ bg, iconBg, icon, valueColor, value, label, Border, originalValue, customInfo }) => (
                  <div key={label} style={{ background: bg, borderRadius: 10, padding: "14px 12px", display: "flex", flexDirection: "column", justifyContent: "space-between", minHeight: 95, border: Border, boxSizing: "border-box" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <div style={{ width: 24, height: 24, borderRadius: 6, background: iconBg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>{icon}</div>
                      <StyledTooltip value={originalValue}>
                        <span style={{ fontSize: "16px", fontWeight: 700, color: valueColor, fontFamily: FONT }}>{value}</span>
                      </StyledTooltip>
                    </div>
                    <p style={{ margin: "8px 0 0", fontSize: "11px", fontWeight: 500, color: "#64748B", display: "flex", gap: "3px", alignItems: "center", fontFamily: FONT }}>
                      <span>{label}</span>
                      {customInfo !== "" && <CustomTooltip title={customInfo || 'NA'}><InfoOutlinedIcon style={{ fontSize: "12px" }} /></CustomTooltip>}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            {/* ── Collected sub-row: expands when purple cards are clicked ── */}
            <div style={{
              maxHeight: expandCollected ? "500px" : "0px",
              opacity: expandCollected ? 1 : 0,
              overflow: "hidden",
              marginBottom: expandCollected ? 16 : 0,
              transition: "max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1), margin-bottom 0.4s cubic-bezier(0.4, 0, 0.2, 1)"
            }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "12px", paddingBottom: 4 }}>
                {/* Large vertical cards row */}
                <div style={{ display: "grid", gridTemplateColumns: isXs ? "1fr 1fr" : "repeat(2, 1fr)", gap: isXs ? 10 : 14 }}>
                  {[
                    { bg: "#ECFDF5", Border: "0.8px solid #DCFCE7", iconBg: "#D1FAE5", iconColor: "#10B981", valueColor: "#047857", value: currentData.collection?.totalCollectedPastDueDisplay ?? "₹0", originalValue: currentData.collection?.totalCollectedPastDue ?? 0, label: "Collected Till Date", customInfo: "Total EMIs Paid", listTab: "COLLECTED", icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" /></svg> },
                    { bg: "#EEF2FF", Border: "0.8px solid #E0E7FF", iconBg: "#E0E7FF", iconColor: "#6366F1", valueColor: "#3730A3", value: currentData.collection?.totalCollectedFutureDueDisplay ?? "₹0", originalValue: currentData.collection?.totalCollectedFutureDue ?? 0, label: "Foreclosure Amount", customInfo: "Total EMIs Paid", listTab: "FORECLOSURE", icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" /></svg> },
                  ].map(({ bg, iconBg, icon, valueColor, value, label, Border, originalValue, customInfo, listTab }) => (
                    <div key={label} style={{ background: bg, borderRadius: 12, padding: "20px 18px", display: "flex", flexDirection: "column", justifyContent: "space-between", minHeight: 110, border: Border }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <div style={{ width: 32, height: 32, borderRadius: 8, background: iconBg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>{icon}</div>
                        <StyledTooltip value={originalValue}>
                          <span style={{ fontSize: "clamp(16px, 2vw, 20px)", fontWeight: 700, color: valueColor, letterSpacing: "-0.5px", lineHeight: 1 }}>{value}</span>
                        </StyledTooltip>
                      </div>
                      <p style={{ margin: "12px 0 0", fontSize: "clamp(11px, 0.9vw, 13px)", fontWeight: 400, color: "#64748B", display: 'flex', gap: '5px', alignItems: 'center', width: '100%' }}>
                        <span>{label}</span>
                        {customInfo !== "" && <CustomTooltip title={customInfo || 'NA'}><InfoOutlinedIcon /></CustomTooltip>}
                        {listTab && (
                          <span
                            onClick={(e) => {
                              e.stopPropagation();
                              setCollectionPopupTab(listTab);
                            }}
                            style={{
                              marginLeft: "auto",
                              cursor: "pointer",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: valueColor,
                              padding: "4px",
                              borderRadius: "6px",
                              background: "rgba(255, 255, 255, 0.65)",
                              border: "0.5px solid rgba(0, 0, 0, 0.08)",
                              transition: "background 0.15s"
                            }}
                            onMouseEnter={e => e.currentTarget.style.background = "#ffffff"}
                            onMouseLeave={e => e.currentTarget.style.background = "rgba(255, 255, 255, 0.65)"}
                            title={`View ${label} Details`}
                          >
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: 'auto' }}>
                              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                              <circle cx="12" cy="12" r="3" />
                            </svg>
                          </span>
                        )}
                      </p>
                    </div>
                  ))}
                </div>

                {/* Small horizontal breakdown cards row */}
                <div style={{ display: "grid", gridTemplateColumns: isXs ? "1fr 1fr" : "repeat(auto-fill, minmax(280px, 1fr))", gap: isXs ? 10 : 12 }}>
                  {[
                    { bg: "#EFF6FF", Border: "0.8px solid #BFDBFE", iconBg: "#DBEAFE", iconColor: "#3B82F6", valueColor: "#1E40AF", value: currentData.collection?.collectedPrincipalDisplay ?? "₹0.00", originalValue: currentData.collection?.collectedPrincipal ?? 0, label: "Principal Amount", customInfo: "Principal portion of collected EMIs", icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" /><line x1="12" y1="8" x2="12.01" y2="8" /></svg> },
                    { bg: "#F0FDF4", Border: "0.8px solid #BBF7D0", iconBg: "#DCFCE7", iconColor: "#22C55E", valueColor: "#15803D", value: currentData.collection?.collectedInterestDisplay ?? "₹0.00", originalValue: currentData.collection?.collectedInterest ?? 0, label: "Interest Amount", customInfo: "Interest portion of collected EMIs", icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#22C55E" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" /><line x1="12" y1="8" x2="12.01" y2="8" /></svg> },
                    { bg: "#FFF7ED", Border: "0.8px solid #FFEDD5", iconBg: "#FFEDD5", iconColor: "#F97316", valueColor: "#C2410C", value: currentData.collection?.collectedOverdueInterestDisplay ?? "₹0.00", originalValue: currentData.collection?.collectedOverdueInterest ?? 0, label: "Overdue Interest", customInfo: "Overdue interest portion of collected EMIs", icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#F97316" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /></svg> },
                    { bg: "#FEF2F2", Border: "0.8px solid #FEE2E2", iconBg: "#FEE2E2", iconColor: "#EF4444", valueColor: "#B91C1C", value: currentData.collection?.collectedPenaltyDisplay ?? "₹0.00", originalValue: currentData.collection?.collectedPenalty ?? 0, label: "Penalty Amount", customInfo: "Penalty portion of collected EMIs", icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#EF4444" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg> },
                    { bg: "#FAF5FF", Border: "0.8px solid #F3E8FF", iconBg: "#F3E8FF", iconColor: "#A855F7", valueColor: "#7E22CE", value: currentData.collection?.collectedBounceDisplay ?? "₹0.00", originalValue: currentData.collection?.collectedBounce ?? 0, label: "Bounce Charges", customInfo: "Bounce portion of collected EMIs", icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#A855F7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m15 9-6 6" /><path d="m9 9 6 6" /></svg> },
                    { bg: "#F8FAFC", Border: "0.8px solid #E2E8F0", iconBg: "#F1F5F9", iconColor: "#64748B", valueColor: "#334155", value: currentData.collection?.collectedWaivedDisplay ?? "₹0.00", originalValue: currentData.collection?.collectedWaived ?? 0, label: "Waived Amount", customInfo: "Waived portion of collected EMIs", icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#64748B" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14" /></svg> },
                  ].map(({ bg, iconBg, icon, valueColor, value, label, Border, originalValue, customInfo }) => (
                    <div key={label} style={{ background: bg, borderRadius: 10, padding: "14px 12px", display: "flex", flexDirection: "column", justifyContent: "space-between", minHeight: 95, border: Border, boxSizing: "border-box" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <div style={{ width: 24, height: 24, borderRadius: 6, background: iconBg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>{icon}</div>
                        <StyledTooltip value={originalValue}>
                          <span style={{ fontSize: "16px", fontWeight: 700, color: valueColor, fontFamily: FONT }}>{value}</span>
                        </StyledTooltip>
                      </div>
                      <p style={{ margin: "8px 0 0", fontSize: "11px", fontWeight: 500, color: "#64748B", display: "flex", gap: "3px", alignItems: "center", fontFamily: FONT }}>
                        <span>{label}</span>
                        {customInfo !== "" && <CustomTooltip title={customInfo || 'NA'}><InfoOutlinedIcon style={{ fontSize: "12px" }} /></CustomTooltip>}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* ── Pending sub-row: expands when yellow card is clicked ── */}
            <div style={{
              maxHeight: expandPending ? "300px" : "0px",
              opacity: expandPending ? 1 : 0,
              overflow: "hidden",
              marginBottom: expandPending ? 16 : 0,
              transition: "max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1), margin-bottom 0.4s cubic-bezier(0.4, 0, 0.2, 1)"
            }}>
              <div style={{ display: "grid", gridTemplateColumns: isXs ? "1fr 1fr" : "repeat(auto-fill, minmax(280px, 1fr))", gap: isXs ? 10 : 12, paddingBottom: 4 }}>
                {[
                  { bg: "#EFF6FF", Border: "0.8px solid #BFDBFE", iconBg: "#DBEAFE", iconColor: "#3B82F6", valueColor: "#1E40AF", value: currentData.collection?.pendingPrincipalDisplay ?? "₹0.00", originalValue: currentData.collection?.pendingPrincipal ?? 0, label: "Principal Amount", customInfo: "Principal portion of pending EMIs", icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" /><line x1="12" y1="8" x2="12.01" y2="8" /></svg> },
                  { bg: "#F0FDF4", Border: "0.8px solid #BBF7D0", iconBg: "#DCFCE7", iconColor: "#22C55E", valueColor: "#15803D", value: currentData.collection?.pendingInterestDisplay ?? "₹0.00", originalValue: currentData.collection?.pendingInterest ?? 0, label: "Interest Amount", customInfo: "Interest portion of pending EMIs", icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#22C55E" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" /><line x1="12" y1="8" x2="12.01" y2="8" /></svg> },
                  { bg: "#FFF7ED", Border: "0.8px solid #FFEDD5", iconBg: "#FFEDD5", iconColor: "#F97316", valueColor: "#C2410C", value: currentData.collection?.pendingOverdueInterestDisplay ?? "₹0.00", originalValue: currentData.collection?.pendingOverdueInterest ?? 0, label: "Overdue Interest", customInfo: "Overdue interest portion of pending EMIs", icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#F97316" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /></svg> },
                  { bg: "#FEF2F2", Border: "0.8px solid #FEE2E2", iconBg: "#FEE2E2", iconColor: "#EF4444", valueColor: "#B91C1C", value: currentData.collection?.pendingPenaltyDisplay ?? "₹0.00", originalValue: currentData.collection?.pendingPenalty ?? 0, label: "Penalty Amount", customInfo: "Penalty portion of pending EMIs", icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#EF4444" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg> },
                  { bg: "#FAF5FF", Border: "0.8px solid #F3E8FF", iconBg: "#F3E8FF", iconColor: "#A855F7", valueColor: "#7E22CE", value: currentData.collection?.pendingBounceDisplay ?? "₹0.00", originalValue: currentData.collection?.pendingBounce ?? 0, label: "Bounce Charges", customInfo: "Bounce portion of pending EMIs", icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#A855F7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m15 9-6 6" /><path d="m9 9 6 6" /></svg> },
                  { bg: "#F8FAFC", Border: "0.8px solid #E2E8F0", iconBg: "#F1F5F9", iconColor: "#64748B", valueColor: "#334155", value: currentData.collection?.pendingWaivedDisplay ?? "₹0.00", originalValue: currentData.collection?.pendingWaived ?? 0, label: "Waived Amount", customInfo: "Waived portion of pending EMIs", icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#64748B" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14" /></svg> },
                ].map(({ bg, iconBg, icon, valueColor, value, label, Border, originalValue, customInfo }) => (
                  <div key={label} style={{ background: bg, borderRadius: 10, padding: "14px 12px", display: "flex", flexDirection: "column", justifyContent: "space-between", minHeight: 95, border: Border, boxSizing: "border-box" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <div style={{ width: 24, height: 24, borderRadius: 6, background: iconBg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>{icon}</div>
                      <StyledTooltip value={originalValue}>
                        <span style={{ fontSize: "16px", fontWeight: 700, color: valueColor, fontFamily: FONT }}>{value}</span>
                      </StyledTooltip>
                    </div>
                    <p style={{ margin: "8px 0 0", fontSize: "11px", fontWeight: 500, color: "#64748B", display: "flex", gap: "3px", alignItems: "center", fontFamily: FONT }}>
                      <span>{label}</span>
                      {customInfo !== "" && <CustomTooltip title={customInfo || 'NA'}><InfoOutlinedIcon style={{ fontSize: "12px" }} /></CustomTooltip>}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            {/* ── Defaulted sub-row: expands when red card is clicked ── */}
            <div style={{
              maxHeight: expandDefaulted ? "600px" : "0px",
              opacity: expandDefaulted ? 1 : 0,
              overflow: "hidden",
              marginBottom: expandDefaulted ? 16 : 0,
              transition: "max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1), margin-bottom 0.4s cubic-bezier(0.4, 0, 0.2, 1)"
            }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "12px", paddingBottom: 4 }}>
                {/* Large vertical cards row */}
                <div style={{ display: "grid", gridTemplateColumns: isXs ? "1fr 1fr" : "repeat(4, 1fr)", gap: isXs ? 10 : 14 }}>
                  {[
                    { bg: "#FFF7ED", Border: "0.8px solid #FED7AA", iconBg: "#FFEDD5", iconColor: "#EA580C", valueColor: "#9A3412",
                      value: currentData.collection?.collectionGap ?? "₹0.00L",
                      originalValue: currentData.collection?.collectionGapOriginal ?? 0,
                      label: "Total Overdue Amount", customInfo: "Total Overdue Amount",
                      icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#EA580C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" /></svg> },
                    { bg: "#FFF7ED", Border: "0.8px solid #FED7AA", iconBg: "#FFEDD5", iconColor: "#EA580C", valueColor: "#9A3412",
                      value: currentData.collection?.defaultedOverdueInterest ?? "₹0.00L",
                      originalValue: currentData.collection?.defaultedOverdueInterestOriginal ?? 0,
                      label: "Defaulted Overdue Interest Amount", customInfo: "Total Overdue Interest",
                      icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#EA580C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" /></svg> },
                    { bg: "#FEF2F2", Border: "0.8px solid #FECACA", iconBg: "#FEE2E2", iconColor: "#DC2626", valueColor: "#991B1B",
                      value: currentData.collection?.defaultedPenalty ?? "₹0.00L",
                      originalValue: currentData.collection?.defaultedPenaltyOriginal ?? 0,
                      label: "Defaulted Penalty Amount", customInfo: "Total Penalty Amount",
                      icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#DC2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg> },
                    { bg: "#FDF4FF", Border: "0.8px solid #F3E8FF", iconBg: "#F3E8FF", iconColor: "#9333EA", valueColor: "#6B21A8",
                      value: currentData.collection?.defaultedBounce ?? "₹0.00L",
                      originalValue: currentData.collection?.defaultedBounceOriginal ?? 0,
                      label: "Defaulted Bounce Charges", customInfo: "Total Bounce Charges",
                      icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9333EA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10" /><path d="m15 9-6 6" /><path d="m9 9 6 6" /><path d="M19 16v6" /><path d="M22 19h-6" /></svg> },
                  ].map(({ bg, iconBg, icon, valueColor, value, label, Border, originalValue, customInfo }) => (
                    <div key={label} style={{ background: bg, borderRadius: 12, padding: "20px 18px", display: "flex", flexDirection: "column", justifyContent: "space-between", minHeight: 110, border: Border }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <div style={{ width: 32, height: 32, borderRadius: 8, background: iconBg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>{icon}</div>
                        <StyledTooltip value={originalValue}>
                          <span style={{ fontSize: "clamp(16px, 2vw, 20px)", fontWeight: 700, color: valueColor, letterSpacing: "-0.5px", lineHeight: 1 }}>{value}</span>
                        </StyledTooltip>
                      </div>
                      <p style={{ margin: "12px 0 0", fontSize: "clamp(11px, 0.9vw, 13px)", fontWeight: 400, color: "#64748B", display: 'flex', gap: '5px' }}>
                        {label}
                        {customInfo !== "" && <CustomTooltip title={customInfo || 'NA'}><InfoOutlinedIcon style={{ fontSize: "11px" }} /></CustomTooltip>}
                      </p>
                    </div>
                  ))}
                </div>

                {/* Small horizontal breakdown cards row */}
                <div style={{ display: "grid", gridTemplateColumns: isXs ? "1fr 1fr" : "repeat(auto-fill, minmax(280px, 1fr))", gap: isXs ? 10 : 12 }}>
                  {[
                    { bg: "#EFF6FF", Border: "0.8px solid #BFDBFE", iconBg: "#DBEAFE", iconColor: "#3B82F6", valueColor: "#1E40AF", value: currentData.collection?.defaultedPrincipalDisplay ?? "₹0.00", originalValue: currentData.collection?.defaultedPrincipal ?? 0, label: "Principal Amount", customInfo: "Principal portion of defaulted EMIs", icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" /><line x1="12" y1="8" x2="12.01" y2="8" /></svg> },
                    { bg: "#F0FDF4", Border: "0.8px solid #BBF7D0", iconBg: "#DCFCE7", iconColor: "#22C55E", valueColor: "#15803D", value: currentData.collection?.defaultedInterestDisplay ?? "₹0.00", originalValue: currentData.collection?.defaultedInterest ?? 0, label: "Interest Amount", customInfo: "Interest portion of defaulted EMIs", icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#22C55E" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" /><line x1="12" y1="8" x2="12.01" y2="8" /></svg> },
                    { bg: "#F8FAFC", Border: "0.8px solid #E2E8F0", iconBg: "#F1F5F9", iconColor: "#64748B", valueColor: "#334155", value: currentData.collection?.defaultedWaivedDisplay ?? "₹0.00", originalValue: currentData.collection?.defaultedWaived ?? 0, label: "Waived Amount", customInfo: "Waived portion of defaulted EMIs", icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#64748B" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14" /></svg> },
                  ].map(({ bg, iconBg, icon, valueColor, value, label, Border, originalValue, customInfo }) => (
                    <div key={label} style={{ background: bg, borderRadius: 10, padding: "14px 12px", display: "flex", flexDirection: "column", justifyContent: "space-between", minHeight: 95, border: Border, boxSizing: "border-box" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <div style={{ width: 24, height: 24, borderRadius: 6, background: iconBg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>{icon}</div>
                        <StyledTooltip value={originalValue}>
                          <span style={{ fontSize: "16px", fontWeight: 700, color: valueColor, fontFamily: FONT }}>{value}</span>
                        </StyledTooltip>
                      </div>
                      <p style={{ margin: "8px 0 0", fontSize: "11px", fontWeight: 500, color: "#64748B", display: "flex", gap: "3px", alignItems: "center", fontFamily: FONT }}>
                        <span>{label}</span>
                        {customInfo !== "" && <CustomTooltip title={customInfo || 'NA'}><InfoOutlinedIcon style={{ fontSize: "12px" }} /></CustomTooltip>}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: isXs ? "1fr" : "1fr 1fr", gap: commonGap, marginTop: '30px' }}>
              {[
                { label: "Collection Rate", value: currentData?.collection?.collectionRate ?? "0%", sub: "Overall Collection Rate", valueColor: "#00A63E", originalValue: null },
                { label: "Total Due Amount", value: currentData?.collection?.defaulted ?? "₹0.00L", originalValue: currentData?.collection?.defaultedOriginal ?? 0, sub: "Pending Collection", valueColor: "#E7000B" },
              ].map(({ label, value, sub, valueColor, originalValue }) => (
                <div key={label} style={{ background: "#F9FAFB", borderRadius: 12, padding: isXs ? "18px 16px" : "22px 24px", border: "0.8px solid #E5E7EB", display: "flex", flexDirection: "column", alignItems: "center", gap: 6 }}>
                  <p style={{ margin: 0, fontSize: "clamp(12px, 1.2vw, 14px)", fontWeight: 400, color: "#374151", alignSelf: "flex-start" }}>{label}</p>
                  {originalValue ? (
                    <StyledTooltip value={originalValue}>
                      <h6 style={{ margin: "8px 0 0", fontSize: window.innerWidth > 1800 ? "50px" : "40px", fontWeight: 700, color: valueColor, letterSpacing: "-1.5px", lineHeight: 1 }}>{value}</h6>
                    </StyledTooltip>
                  ) : (
                    <h6 style={{ margin: "8px 0 0", fontSize: window.innerWidth > 1800 ? "50px" : "40px", fontWeight: 700, color: valueColor, letterSpacing: "-1.5px", lineHeight: 1 }}>{value}</h6>
                  )}
                  <p style={{ margin: "4px 0 0", fontSize: "clamp(10px, 0.8vw, 12px)", color: "#6B7280", fontWeight: 400 }}>{sub}</p>
                </div>
              ))}
            </div>
          </>
        )}
      </div>

      {/* ── Promise to Pay (PTP) Section ── */}
      {/* <div style={{ background: "#fff", borderRadius: 16, padding: sectionPad, border: "1px solid #E5E7EB", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", margin: "20px auto", maxWidth: 2500, marginTop: commonMargin }}>
        <div style={{ marginBottom: isXs ? 16 : 20 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
            <div style={{ width: 20, height: 20, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <i className="fa fa-handshake-o" style={{ color: "#EF4444", fontSize: "18px" }}></i>
            </div>
            <h2 style={{ margin: 0, fontSize: "20px", fontWeight: 600, color: "#101828" }}>Promise to Pay (PTP) Records</h2>
          </div>
          <p style={{ margin: "8px 0", fontSize: "14px", color: "#6A7282", fontWeight: "400" }}>
            PTP records set against defaulted EMI amounts
          </p>
        </div>

        {ptpRecords.length === 0 ? (
          <div style={{ padding: "30px 20px", textAlign: "center", color: "#64748B", background: "#F8FAFC", borderRadius: "12px", border: "1.5px dashed #cbd5e1" }}>
            No Promise to Pay records created yet. Click the <strong>PTP</strong> button on the Defaulted EMI card to add one.
          </div>
        ) : (
          <div style={{ overflowX: "auto", border: "1px solid #E2E8F0", borderRadius: "12px" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left" }}>
              <thead>
                <tr style={{ background: "#F8FAFC", borderBottom: "1.5px solid #E2E8F0" }}>
                  <th style={{ padding: "12px 16px", fontSize: "12px", fontWeight: "600", color: "#475569", textTransform: "uppercase" }}>Month</th>
                  <th style={{ padding: "12px 16px", fontSize: "12px", fontWeight: "600", color: "#475569", textTransform: "uppercase" }}>PTP Amount</th>
                  <th style={{ padding: "12px 16px", fontSize: "12px", fontWeight: "600", color: "#475569", textTransform: "uppercase" }}>Created Date</th>
                  <th style={{ padding: "12px 16px", fontSize: "12px", fontWeight: "600", color: "#475569", textTransform: "uppercase", textAlign: "right" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {ptpRecords.map((record) => (
                  <tr key={record.id} style={{ borderBottom: "1px solid #F1F5F9" }}>
                    <td style={{ padding: "14px 16px", fontSize: "13.5px", fontWeight: "600", color: "#0F172A" }}>
                      {moment(record.month, "YYYY-MM").format("MMMM YYYY")} <span style={{ fontSize: "12px", fontWeight: "400", color: "#64748b", marginLeft: "6px" }}>({record.formattedDate})</span>
                    </td>
                    <td style={{ padding: "14px 16px", fontSize: "13.5px", fontWeight: "700", color: "#EF4444" }}>
                      {formatCurrency(record.amount)}
                    </td>
                    <td style={{ padding: "14px 16px", fontSize: "13px", color: "#64748B" }}>
                      {record.createdDate}
                    </td>
                    <td style={{ padding: "14px 16px", textAlign: "right" }}>
                      <button
                        onClick={() => handleEditClick(record)}
                        style={{
                          background: "transparent",
                          border: "none",
                          color: "#3B82F6",
                          cursor: "pointer",
                          fontSize: "12.5px",
                          fontWeight: "600",
                          padding: "4px 8px",
                          borderRadius: "4px",
                          marginRight: "8px",
                          transition: "background 0.15s"
                        }}
                        onMouseEnter={e => e.currentTarget.style.background = "#EFF6FF"}
                        onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => handleDeletePtp(record)}
                        style={{
                          background: "transparent",
                          border: "none",
                          color: "#EF4444",
                          cursor: "pointer",
                          fontSize: "12.5px",
                          fontWeight: "600",
                          padding: "4px 8px",
                          borderRadius: "4px",
                          transition: "background 0.15s"
                        }}
                        onMouseEnter={e => e.currentTarget.style.background = "#FEE2E2"}
                        onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div> */}

      {/* ── Render detail list modal popup when active ── */}
      {collectionPopupTab && (
        <CollectionListPopup
          tab={collectionPopupTab}
          onClose={() => setCollectionPopupTab(null)}
          currentFilterDate={currentFilterDate}
          nbfc={commonFilter?.nbfc}
        />
      )}

      {/* ── Promise to Pay Input Modal ── */}
      {showPtpModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15, 23, 42, 0.45)",
            backdropFilter: "blur(4px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            padding: 20,
            animation: "backdropIn 0.2s ease",
          }}
          onClick={(e) => {
            if (e.target === e.currentTarget) setShowPtpModal(false);
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: 450,
              background: "#ffffff",
              borderRadius: 20,
              padding: 28,
              boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
              border: "1px solid #e2e8f0",
              animation: "modalIn 0.25s cubic-bezier(0.16, 1, 0.3, 1)",
            }}
          >
            {/* Header */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ width: 36, height: 36, borderRadius: "10px", background: "#FEE2E2", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <i className="fa fa-handshake-o" style={{ color: "#EF4444", fontSize: "18px" }}></i>
                </div>
                <div>
                  <h3 style={{ margin: 0, fontSize: "18px", fontWeight: 700, color: "#1e293b" }}>{editingPtpRecord ? "Edit Promise to Pay" : "Create Promise to Pay"}</h3>
                  <p style={{ margin: 0, fontSize: "12px", color: "#64748b" }}>{editingPtpRecord ? "Update details for this PTP" : "Set PTP details for defaulted amount"}</p>
                </div>
              </div>
              <button
                onClick={() => setShowPtpModal(false)}
                style={{ background: "none", border: "none", cursor: "pointer", padding: 6, display: "flex" }}
              >
                <i className="fa fa-times" style={{ color: "#94a3b8", fontSize: "18px" }}></i>
              </button>
            </div>

            {/* Form */}
            <form onSubmit={handleSavePtp}>
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: "#475569", marginBottom: 8 }}>
                  PTP Amount (₹)
                </label>
                <input
                  type="number"
                  required
                  placeholder="Enter amount"
                  value={ptpAmount}
                  onChange={(e) => setPtpAmount(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px 14px",
                    borderRadius: "10px",
                    border: "1.5px solid #CBD5E1",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#1e293b",
                    outline: "none",
                    boxSizing: "border-box"
                  }}
                />
              </div>

              <div style={{ marginBottom: 24 }}>
                <label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: "#475569", marginBottom: 8 }}>
                  Select Month and Year
                </label>
                <div style={{ display: "flex", gap: "12px" }}>
                  <select
                    required
                    value={ptpMonth}
                    onChange={(e) => setPtpMonth(e.target.value)}
                    style={{
                      flex: 1,
                      padding: "10px 14px",
                      borderRadius: "10px",
                      border: "1.5px solid #CBD5E1",
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "#1e293b",
                      outline: "none",
                      background: "#fff"
                    }}
                  >
                    <option value="">Month</option>
                    {monthsList.map((m) => (
                      <option key={m.value} value={m.value}>{m.label}</option>
                    ))}
                  </select>
                  
                  <select
                    required
                    value={ptpYear}
                    onChange={(e) => setPtpYear(e.target.value)}
                    style={{
                      flex: 1,
                      padding: "10px 14px",
                      borderRadius: "10px",
                      border: "1.5px solid #CBD5E1",
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "#1e293b",
                      outline: "none",
                      background: "#fff"
                    }}
                  >
                    <option value="">Year</option>
                    {yearsList.map((y) => (
                      <option key={y} value={y}>{y}</option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Footer Buttons */}
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, borderTop: "1px solid #e2e8f0", paddingTop: 18 }}>
                <button
                  type="button"
                  onClick={() => setShowPtpModal(false)}
                  style={{
                    padding: "9px 18px",
                    borderRadius: "10px",
                    background: "#F1F5F9",
                    border: "1px solid #E2E8F0",
                    fontWeight: "600",
                    color: "#475569",
                    cursor: "pointer",
                    fontSize: "13px",
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  style={{
                    padding: "9px 18px",
                    borderRadius: "10px",
                    background: "linear-gradient(135deg, #EF4444 0%, #B91C1C 100%)",
                    border: "none",
                    fontWeight: "600",
                    color: "#fff",
                    cursor: "pointer",
                    fontSize: "13px",
                    boxShadow: "0 2px 6px rgba(239, 68, 68, 0.2)"
                  }}
                >
                  {editingPtpRecord ? "Update Promise" : "Save Promise"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

/* ═══════════════════════════════════════════════════════════════════════ */
/*  CollectionListPopup Component                                          */
/* ═══════════════════════════════════════════════════════════════════════ */
function CollectionListPopup({ tab, onClose, currentFilterDate, nbfc }) {
  const [currentPage, setCurrentPage] = useState(0); // 0-indexed page
  const [tableData, setTableData] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const [loader, setLoader] = useState(false);
  const [hovered, setHovered] = useState(null);
  const [summaryData, setSummaryData] = useState(null);

  const size = 10; // fixed size as requested

  useEffect(() => {
    setLoader(true);
    const requestData = {
      tab,
      startDate: currentFilterDate?.start || "",
      endDate: currentFilterDate?.end || "",
      nbfcId: nbfc || "",
      productId: "",
      loanId: "",
      userId: "",
      name: "",
      loanStatus: "",
      emiStatus: null,
      page: currentPage,
      size
    };

    getMisCollectionList(
      requestData,
      (res) => {
        setLoader(false);
        const rootData = (res?.status === 200) ? res.data : res;
        const recordsList = Array.isArray(rootData?.data) ? rootData.data : (Array.isArray(rootData) ? rootData : []);
        const total = rootData?.totalRecords ?? rootData?.totalElements ?? recordsList.length;

        setTableData(recordsList);
        setTotalElements(total);
        setSummaryData(rootData);
      },
      (err) => {
        setLoader(false);
        console.error("Failed to load collection list:", err);
        setTableData([]);
        setTotalElements(0);
      }
    );
  }, [tab, currentPage, currentFilterDate, nbfc]);

  const fmtVal = (val) => {
    if (val === null || val === undefined) return "—";
    if (typeof val === "string" && val.includes("₹")) return val;
    const num = Number(val);
    if (isNaN(num)) return String(val);
    return `₹${num.toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;
  };

  const columns = [
    { header: "Application ID", accessor: (r) => r.applicationId ?? "—" },
    { header: "User Name", accessor: (r) => r.name ?? r.userName ?? "—" },
    { header: "Disburse Date", accessor: (r) => r.loanDisburseDate ?? "—" },
    { header: "EMI Date", accessor: (r) => r.emiDate ?? "—" },
    { header: "Principal", accessor: (r) => fmtVal(r.emiPrincipal) },
    { header: "Interest", accessor: (r) => fmtVal(r.emiInterest) },
    { header: "EMI Amount", accessor: (r) => fmtVal(r.emiAmount) },
    { header: "Total Collectable Amount", accessor: (r) => fmtVal(r?.collectableAmount) }, //new
    { header: "Paid Amount", accessor: (r) => fmtVal(r.paidAmount) },
    { header: "Paid Date", accessor: (r) => r.paidDate ?? "—" },
    { header: "Overdue Amount", accessor: (r) => fmtVal(r.emiOverdueAmount) },
    { header: "Amount Pending", accessor: (r) => fmtVal(r?.amountPending) }, //new
    { header: "EMI Pending", accessor: (r) => fmtVal(r?.emiPending) }, //new
    { header: "Status", accessor: (r) => r.emiStatus === true ? "PAID" : "UNPAID" },
  ];

  const totalPages = Math.ceil(totalElements / size);

  return (
    <div style={{
      position: "fixed",
      inset: 0,
      background: "rgba(15, 23, 42, 0.45)",
      backdropFilter: "blur(4px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1100,
      padding: "24px",
    }} onClick={(e) => e.target === e.currentTarget && onClose()}>
      
      <div style={{
        background: "#ffffff",
        borderRadius: "16px",
        border: "1px solid #e2e8f0",
        width: "100%",
        maxWidth: "1150px",
        maxHeight: "90vh",
        boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        position: "relative"
      }}>
        
        {loader && (
          <div style={{
            position: "absolute",
            inset: 0,
            background: "rgba(255,255,255,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10
          }}>
            <div className="spinner-border text-primary" role="status" style={{ width: "32px", height: "32px" }}>
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}

        {/* Header */}
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "18px 24px",
          borderBottom: "1px solid #f1f5f9"
        }}>
          <div>
            <h3 style={{ margin: 0, fontSize: "16px", fontWeight: "700", color: "#0f172a", textTransform: "capitalize" }}>
              {tab.replace(/_/g, " ").toLowerCase()} List Details
            </h3>
            <span style={{ fontSize: "12.5px", color: "#64748b", fontWeight: "500" }}>
              Showing {tableData.length} of {totalElements} elements found
            </span>
          </div>
          <button onClick={onClose} style={{
            background: "#f1f5f9",
            border: "none",
            borderRadius: "50%",
            width: "30px",
            height: "30px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            color: "#64748b",
            transition: "all 0.15s"
          }}
            onMouseEnter={e => e.currentTarget.style.background = "#e2e8f0"}
            onMouseLeave={e => e.currentTarget.style.background = "#f1f5f9"}
          >
            ✕
          </button>
        </div>

        {/* Summary metrics header bar */}
        {/* {summaryData && (
          <div style={{
            display: "flex",
            gap: "24px",
            background: "#f8fafc",
            padding: "14px 24px",
            borderBottom: "1px solid #e2e8f0",
            flexWrap: "wrap",
            alignItems: "center"
          }}>
            <div style={{ fontSize: "13.5px", color: "#475569" }}>
              <strong>Total EMI Amount:</strong> <span style={{ color: "#1e40af", fontWeight: "700", marginLeft: "4px" }}>{summaryData.totalEmiAmountDisplay ?? fmtVal(summaryData.totalEmiAmount)}</span>
            </div>
            <div style={{ fontSize: "13.5px", color: "#475569" }}>
              <strong>Total Paid Amount:</strong> <span style={{ color: "#15803d", fontWeight: "700", marginLeft: "4px" }}>{summaryData.totalPaidAmountDisplay ?? fmtVal(summaryData.totalPaidAmount)}</span>
            </div>
            <div style={{ fontSize: "13.5px", color: "#475569" }}>
              <strong>Total Overdue Amount:</strong> <span style={{ color: "#b91c1c", fontWeight: "700", marginLeft: "4px" }}>{summaryData.totalOverdueAmountDisplay ?? fmtVal(summaryData.totalOverdueAmount)}</span>
            </div>
          </div>
        )} */}

        {/* Table Body container */}
        <div style={{ flex: 1, overflowY: "auto", padding: "12px 24px" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ borderBottom: "2px solid #f1f5f9" }}>
                {columns.map((col) => (
                  <th key={col.header} style={{
                    padding: "12px 10px",
                    textAlign: "left",
                    fontSize: "12px",
                    fontWeight: "700",
                    color: "#64748b",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px"
                  }}>{col.header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tableData.length === 0 ? (
                <tr>
                  <td colSpan={columns.length} style={{
                    padding: "48px 0",
                    textAlign: "center",
                    color: "#94a3b8",
                    fontSize: "14px",
                    fontWeight: "500"
                  }}>
                    No records found for the selected tab and date range.
                  </td>
                </tr>
              ) : (
                tableData.map((row, idx) => (
                  <tr
                    key={idx}
                    style={{
                      borderBottom: "1px solid #f8fafc",
                      background: hovered === idx ? "#f8fafc" : "transparent",
                      transition: "background 0.1s"
                    }}
                    onMouseEnter={() => setHovered(idx)}
                    onMouseLeave={() => setHovered(null)}
                  >
                    {columns.map((col, colIdx) => (
                      <td key={colIdx} style={{
                        padding: "12px 10px",
                        fontSize: "13px",
                        fontWeight: colIdx === 0 ? "600" : "500",
                        color: colIdx === 0 ? "#0f172a" : "#475569",
                        whiteSpace: "nowrap"
                      }}>
                        {col.accessor(row)}
                      </td>
                    ))}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Footer with Pagination */}
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "16px 24px",
          borderTop: "1px solid #f1f5f9",
          background: "#fafafa"
        }}>
          {totalPages > 1 ? (
            <div style={{ display: "flex", gap: "6px" }}>
              <button
                disabled={currentPage === 0}
                onClick={() => setCurrentPage((p) => p - 1)}
                style={{
                  padding: "6px 12px",
                  borderRadius: "6px",
                  border: "1px solid #cbd5e1",
                  background: currentPage === 0 ? "#f1f5f9" : "#ffffff",
                  color: currentPage === 0 ? "#94a3b8" : "#475569",
                  cursor: currentPage === 0 ? "not-allowed" : "pointer",
                  fontSize: "13px",
                  fontWeight: "600"
                }}
              >
                Prev
              </button>

              {Array.from({ length: totalPages }, (_, i) => i)
                .slice(Math.max(0, currentPage - 2), currentPage + 3)
                .map((pageIdx) => (
                  <button
                    key={pageIdx}
                    onClick={() => setCurrentPage(pageIdx)}
                    style={{
                      padding: "6px 12px",
                      borderRadius: "6px",
                      border: "1px solid #cbd5e1",
                      background: currentPage === pageIdx ? "#4f46e5" : "#ffffff",
                      color: currentPage === pageIdx ? "#ffffff" : "#475569",
                      cursor: "pointer",
                      fontSize: "13px",
                      fontWeight: "600"
                    }}
                  >
                    {pageIdx + 1}
                  </button>
                ))}

              <button
                disabled={currentPage >= totalPages - 1}
                onClick={() => setCurrentPage((p) => p + 1)}
                style={{
                  padding: "6px 12px",
                  borderRadius: "6px",
                  border: "1px solid #cbd5e1",
                  background: currentPage >= totalPages - 1 ? "#f1f5f9" : "#ffffff",
                  color: currentPage >= totalPages - 1 ? "#94a3b8" : "#475569",
                  cursor: currentPage >= totalPages - 1 ? "not-allowed" : "pointer",
                  fontSize: "13px",
                  fontWeight: "600"
                }}
              >
                Next
              </button>
            </div>
          ) : (
            <div />
          )}

          <button onClick={onClose} style={{
            padding: "8px 18px",
            borderRadius: "8px",
            background: "#4f46e5",
            border: "none",
            color: "#ffffff",
            fontWeight: "600",
            cursor: "pointer",
            fontSize: "13px",
            boxShadow: "0 2px 4px rgba(79, 70, 229, 0.15)",
            transition: "all 0.15s"
          }}
            onMouseEnter={e => e.currentTarget.style.background = "#4338ca"}
            onMouseLeave={e => e.currentTarget.style.background = "#4f46e5"}
          >
            Close
          </button>
        </div>

      </div>
    </div>
  );
}